// game.js
const $0549f5aaef62b2d2$export$d155b7b3d8e33c99 = {
    DAILY: "daily",
    PRACTICE: "practice"
};
const $0549f5aaef62b2d2$export$da9ab7b2fd5998e8 = 5;
const $0549f5aaef62b2d2$export$5aae9b6b3e0e7094 = {
    CURRENT_SCORE: "currentScore",
    HIGH_SCORE: "highScore",
    STREAK: "streak",
    LIFETIME_HINTS: "lifetimeHintsUsed",
    LAST_PLAYED: "lastPlayed",
    GAME_STATE: "gameState",
    THEME: "theme",
    FIRST_TIME: "firstTime",
    PRACTICE_GAME_ORDER: "practiceGameOrder",
    PRACTICE_GAME_INDEX: "practiceGameIndex"
};
const $0549f5aaef62b2d2$export$ce0e5beb5efeb79 = {
    DARK: "dark",
    LIGHT: "light"
};
const $0549f5aaef62b2d2$export$e5fcfdba4a8ae715 = {
    SUCCESS: "success",
    ERROR: "error",
    INFO: "info",
    WARNING: "warning"
};


const $91900f9c9606830c$export$bf2a15d34f3c441c = {
    get (key, defaultValue = null) {
        const value = localStorage.getItem(key);
        if (value === null) return defaultValue;
        try {
            return JSON.parse(value);
        } catch (e) {
            console.error(`Error parsing localStorage key "${key}":`, e);
            return defaultValue;
        }
    },
    set (key, value) {
        try {
            localStorage.setItem(key, JSON.stringify(value));
        } catch (e) {
            console.error(`Error setting localStorage key "${key}":`, e);
        }
    },
    remove (key) {
        localStorage.removeItem(key);
    }
};




function $45ffa6ee91549f09$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $45ffa6ee91549f09$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $45ffa6ee91549f09$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $45ffa6ee91549f09$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $45ffa6ee91549f09$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $45ffa6ee91549f09$var$normalizeComputedStyleValue(string) {
    // "250px" --> 250
    return +string.replace(/px/, "");
}
function $45ffa6ee91549f09$var$fixDPR(canvas) {
    var dpr = window.devicePixelRatio;
    var computedStyles = getComputedStyle(canvas);
    var width = $45ffa6ee91549f09$var$normalizeComputedStyleValue(computedStyles.getPropertyValue("width"));
    var height = $45ffa6ee91549f09$var$normalizeComputedStyleValue(computedStyles.getPropertyValue("height"));
    canvas.setAttribute("width", (width * dpr).toString());
    canvas.setAttribute("height", (height * dpr).toString());
}
function $45ffa6ee91549f09$var$generateRandomNumber(min, max) {
    var fractionDigits = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var randomNumber = Math.random() * (max - min) + min;
    return Math.floor(randomNumber * Math.pow(10, fractionDigits)) / Math.pow(10, fractionDigits);
}
function $45ffa6ee91549f09$var$generateRandomArrayElement(arr) {
    return arr[$45ffa6ee91549f09$var$generateRandomNumber(0, arr.length)];
}
var $45ffa6ee91549f09$var$FREE_FALLING_OBJECT_ACCELERATION = 0.00125;
var $45ffa6ee91549f09$var$MIN_DRAG_FORCE_COEFFICIENT = 0.0005;
var $45ffa6ee91549f09$var$MAX_DRAG_FORCE_COEFFICIENT = 0.0009;
var $45ffa6ee91549f09$var$ROTATION_SLOWDOWN_ACCELERATION = 0.00001;
var $45ffa6ee91549f09$var$INITIAL_SHAPE_RADIUS = 6;
var $45ffa6ee91549f09$var$INITIAL_EMOJI_SIZE = 80;
var $45ffa6ee91549f09$var$MIN_INITIAL_CONFETTI_SPEED = 0.9;
var $45ffa6ee91549f09$var$MAX_INITIAL_CONFETTI_SPEED = 1.7;
var $45ffa6ee91549f09$var$MIN_FINAL_X_CONFETTI_SPEED = 0.2;
var $45ffa6ee91549f09$var$MAX_FINAL_X_CONFETTI_SPEED = 0.6;
var $45ffa6ee91549f09$var$MIN_INITIAL_ROTATION_SPEED = 0.03;
var $45ffa6ee91549f09$var$MAX_INITIAL_ROTATION_SPEED = 0.07;
var $45ffa6ee91549f09$var$MIN_CONFETTI_ANGLE = 15;
var $45ffa6ee91549f09$var$MAX_CONFETTI_ANGLE = 82;
var $45ffa6ee91549f09$var$MAX_CONFETTI_POSITION_SHIFT = 150;
var $45ffa6ee91549f09$var$SHAPE_VISIBILITY_TRESHOLD = 100;
var $45ffa6ee91549f09$var$DEFAULT_CONFETTI_NUMBER = 250;
var $45ffa6ee91549f09$var$DEFAULT_EMOJIS_NUMBER = 40;
var $45ffa6ee91549f09$var$DEFAULT_CONFETTI_COLORS = [
    "#fcf403",
    "#62fc03",
    "#f4fc03",
    "#03e7fc",
    "#03fca5",
    "#a503fc",
    "#fc03ad",
    "#fc03c2"
];
function $45ffa6ee91549f09$var$getWindowWidthCoefficient(canvasWidth) {
    var HD_SCREEN_WIDTH = 1920;
    return Math.log(canvasWidth) / Math.log(HD_SCREEN_WIDTH);
}
var $45ffa6ee91549f09$var$ConfettiShape = /*#__PURE__*/ function() {
    function ConfettiShape(args) {
        $45ffa6ee91549f09$var$_classCallCheck(this, ConfettiShape);
        var initialPosition = args.initialPosition, direction = args.direction, confettiRadius = args.confettiRadius, confettiColors = args.confettiColors, emojis = args.emojis, emojiSize = args.emojiSize, canvasWidth = args.canvasWidth;
        var randomConfettiSpeed = $45ffa6ee91549f09$var$generateRandomNumber($45ffa6ee91549f09$var$MIN_INITIAL_CONFETTI_SPEED, $45ffa6ee91549f09$var$MAX_INITIAL_CONFETTI_SPEED, 3);
        var initialSpeed = randomConfettiSpeed * $45ffa6ee91549f09$var$getWindowWidthCoefficient(canvasWidth);
        this.confettiSpeed = {
            x: initialSpeed,
            y: initialSpeed
        };
        this.finalConfettiSpeedX = $45ffa6ee91549f09$var$generateRandomNumber($45ffa6ee91549f09$var$MIN_FINAL_X_CONFETTI_SPEED, $45ffa6ee91549f09$var$MAX_FINAL_X_CONFETTI_SPEED, 3);
        this.rotationSpeed = emojis.length ? 0.01 : $45ffa6ee91549f09$var$generateRandomNumber($45ffa6ee91549f09$var$MIN_INITIAL_ROTATION_SPEED, $45ffa6ee91549f09$var$MAX_INITIAL_ROTATION_SPEED, 3) * $45ffa6ee91549f09$var$getWindowWidthCoefficient(canvasWidth);
        this.dragForceCoefficient = $45ffa6ee91549f09$var$generateRandomNumber($45ffa6ee91549f09$var$MIN_DRAG_FORCE_COEFFICIENT, $45ffa6ee91549f09$var$MAX_DRAG_FORCE_COEFFICIENT, 6);
        this.radius = {
            x: confettiRadius,
            y: confettiRadius
        };
        this.initialRadius = confettiRadius;
        this.rotationAngle = direction === "left" ? $45ffa6ee91549f09$var$generateRandomNumber(0, 0.2, 3) : $45ffa6ee91549f09$var$generateRandomNumber(-0.2, 0, 3);
        this.emojiSize = emojiSize;
        this.emojiRotationAngle = $45ffa6ee91549f09$var$generateRandomNumber(0, 2 * Math.PI);
        this.radiusYUpdateDirection = "down";
        var angle = direction === "left" ? $45ffa6ee91549f09$var$generateRandomNumber($45ffa6ee91549f09$var$MAX_CONFETTI_ANGLE, $45ffa6ee91549f09$var$MIN_CONFETTI_ANGLE) * Math.PI / 180 : $45ffa6ee91549f09$var$generateRandomNumber(-$45ffa6ee91549f09$var$MIN_CONFETTI_ANGLE, -$45ffa6ee91549f09$var$MAX_CONFETTI_ANGLE) * Math.PI / 180;
        this.absCos = Math.abs(Math.cos(angle));
        this.absSin = Math.abs(Math.sin(angle));
        var positionShift = $45ffa6ee91549f09$var$generateRandomNumber(-$45ffa6ee91549f09$var$MAX_CONFETTI_POSITION_SHIFT, 0);
        var shiftedInitialPosition = {
            x: initialPosition.x + (direction === "left" ? -positionShift : positionShift) * this.absCos,
            y: initialPosition.y - positionShift * this.absSin
        };
        this.currentPosition = Object.assign({}, shiftedInitialPosition);
        this.initialPosition = Object.assign({}, shiftedInitialPosition);
        this.color = emojis.length ? null : $45ffa6ee91549f09$var$generateRandomArrayElement(confettiColors);
        this.emoji = emojis.length ? $45ffa6ee91549f09$var$generateRandomArrayElement(emojis) : null;
        this.createdAt = new Date().getTime();
        this.direction = direction;
    }
    $45ffa6ee91549f09$var$_createClass(ConfettiShape, [
        {
            key: "draw",
            value: function draw(canvasContext) {
                var currentPosition = this.currentPosition, radius = this.radius, color = this.color, emoji = this.emoji, rotationAngle = this.rotationAngle, emojiRotationAngle = this.emojiRotationAngle, emojiSize = this.emojiSize;
                var dpr = window.devicePixelRatio;
                if (color) {
                    canvasContext.fillStyle = color;
                    canvasContext.beginPath();
                    canvasContext.ellipse(currentPosition.x * dpr, currentPosition.y * dpr, radius.x * dpr, radius.y * dpr, rotationAngle, 0, 2 * Math.PI);
                    canvasContext.fill();
                } else if (emoji) {
                    canvasContext.font = "".concat(emojiSize, "px serif");
                    canvasContext.save();
                    canvasContext.translate(dpr * currentPosition.x, dpr * currentPosition.y);
                    canvasContext.rotate(emojiRotationAngle);
                    canvasContext.textAlign = "center";
                    canvasContext.fillText(emoji, 0, 0);
                    canvasContext.restore();
                }
            }
        },
        {
            key: "updatePosition",
            value: function updatePosition(iterationTimeDelta, currentTime) {
                var confettiSpeed = this.confettiSpeed, dragForceCoefficient = this.dragForceCoefficient, finalConfettiSpeedX = this.finalConfettiSpeedX, radiusYUpdateDirection = this.radiusYUpdateDirection, rotationSpeed = this.rotationSpeed, createdAt = this.createdAt, direction = this.direction;
                var timeDeltaSinceCreation = currentTime - createdAt;
                if (confettiSpeed.x > finalConfettiSpeedX) this.confettiSpeed.x -= dragForceCoefficient * iterationTimeDelta;
                this.currentPosition.x += confettiSpeed.x * (direction === "left" ? -this.absCos : this.absCos) * iterationTimeDelta;
                this.currentPosition.y = this.initialPosition.y - confettiSpeed.y * this.absSin * timeDeltaSinceCreation + $45ffa6ee91549f09$var$FREE_FALLING_OBJECT_ACCELERATION * Math.pow(timeDeltaSinceCreation, 2) / 2;
                this.rotationSpeed -= this.emoji ? 0.0001 : $45ffa6ee91549f09$var$ROTATION_SLOWDOWN_ACCELERATION * iterationTimeDelta;
                if (this.rotationSpeed < 0) this.rotationSpeed = 0; // no need to update rotation radius for emoji
                if (this.emoji) {
                    this.emojiRotationAngle += this.rotationSpeed * iterationTimeDelta % (2 * Math.PI);
                    return;
                }
                if (radiusYUpdateDirection === "down") {
                    this.radius.y -= iterationTimeDelta * rotationSpeed;
                    if (this.radius.y <= 0) {
                        this.radius.y = 0;
                        this.radiusYUpdateDirection = "up";
                    }
                } else {
                    this.radius.y += iterationTimeDelta * rotationSpeed;
                    if (this.radius.y >= this.initialRadius) {
                        this.radius.y = this.initialRadius;
                        this.radiusYUpdateDirection = "down";
                    }
                }
            }
        },
        {
            key: "getIsVisibleOnCanvas",
            value: function getIsVisibleOnCanvas(canvasHeight) {
                return this.currentPosition.y < canvasHeight + $45ffa6ee91549f09$var$SHAPE_VISIBILITY_TRESHOLD;
            }
        }
    ]);
    return ConfettiShape;
}();
function $45ffa6ee91549f09$var$createCanvas() {
    var canvas = document.createElement("canvas");
    canvas.style.position = "fixed";
    canvas.style.width = "100%";
    canvas.style.height = "100%";
    canvas.style.top = "0";
    canvas.style.left = "0";
    canvas.style.zIndex = "1000";
    canvas.style.pointerEvents = "none";
    document.body.appendChild(canvas);
    return canvas;
}
function $45ffa6ee91549f09$var$normalizeConfettiConfig(confettiConfig) {
    var _confettiConfig$confe = confettiConfig.confettiRadius, confettiRadius = _confettiConfig$confe === void 0 ? $45ffa6ee91549f09$var$INITIAL_SHAPE_RADIUS : _confettiConfig$confe, _confettiConfig$confe2 = confettiConfig.confettiNumber, confettiNumber = _confettiConfig$confe2 === void 0 ? confettiConfig.confettiesNumber || (confettiConfig.emojis ? $45ffa6ee91549f09$var$DEFAULT_EMOJIS_NUMBER : $45ffa6ee91549f09$var$DEFAULT_CONFETTI_NUMBER) : _confettiConfig$confe2, _confettiConfig$confe3 = confettiConfig.confettiColors, confettiColors = _confettiConfig$confe3 === void 0 ? $45ffa6ee91549f09$var$DEFAULT_CONFETTI_COLORS : _confettiConfig$confe3, _confettiConfig$emoji = confettiConfig.emojis, emojis = _confettiConfig$emoji === void 0 ? confettiConfig.emojies || [] : _confettiConfig$emoji, _confettiConfig$emoji2 = confettiConfig.emojiSize, emojiSize = _confettiConfig$emoji2 === void 0 ? $45ffa6ee91549f09$var$INITIAL_EMOJI_SIZE : _confettiConfig$emoji2; // deprecate wrong plural forms, used in early releases
    if (confettiConfig.emojies) console.error("emojies argument is deprecated, please use emojis instead");
    if (confettiConfig.confettiesNumber) console.error("confettiesNumber argument is deprecated, please use confettiNumber instead");
    return {
        confettiRadius: confettiRadius,
        confettiNumber: confettiNumber,
        confettiColors: confettiColors,
        emojis: emojis,
        emojiSize: emojiSize
    };
}
var $45ffa6ee91549f09$var$ConfettiBatch = /*#__PURE__*/ function() {
    function ConfettiBatch(canvasContext) {
        var _this = this;
        $45ffa6ee91549f09$var$_classCallCheck(this, ConfettiBatch);
        this.canvasContext = canvasContext;
        this.shapes = [];
        this.promise = new Promise(function(completionCallback) {
            return _this.resolvePromise = completionCallback;
        });
    }
    $45ffa6ee91549f09$var$_createClass(ConfettiBatch, [
        {
            key: "getBatchCompletePromise",
            value: function getBatchCompletePromise() {
                return this.promise;
            }
        },
        {
            key: "addShapes",
            value: function addShapes() {
                var _this$shapes;
                (_this$shapes = this.shapes).push.apply(_this$shapes, arguments);
            }
        },
        {
            key: "complete",
            value: function complete() {
                var _a;
                if (this.shapes.length) return false;
                (_a = this.resolvePromise) === null || _a === void 0 || _a.call(this);
                return true;
            }
        },
        {
            key: "processShapes",
            value: function processShapes(time, canvasHeight, cleanupInvisibleShapes) {
                var _this2 = this;
                var timeDelta = time.timeDelta, currentTime = time.currentTime;
                this.shapes = this.shapes.filter(function(shape) {
                    // Render the shapes in this batch
                    shape.updatePosition(timeDelta, currentTime);
                    shape.draw(_this2.canvasContext); // Only cleanup the shapes if we're being asked to
                    if (!cleanupInvisibleShapes) return true;
                    return shape.getIsVisibleOnCanvas(canvasHeight);
                });
            }
        }
    ]);
    return ConfettiBatch;
}();
var $45ffa6ee91549f09$var$JSConfetti = /*#__PURE__*/ function() {
    function JSConfetti() {
        var jsConfettiConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        $45ffa6ee91549f09$var$_classCallCheck(this, JSConfetti);
        this.activeConfettiBatches = [];
        this.canvas = jsConfettiConfig.canvas || $45ffa6ee91549f09$var$createCanvas();
        this.canvasContext = this.canvas.getContext("2d");
        this.requestAnimationFrameRequested = false;
        this.lastUpdated = new Date().getTime();
        this.iterationIndex = 0;
        this.loop = this.loop.bind(this);
        requestAnimationFrame(this.loop);
    }
    $45ffa6ee91549f09$var$_createClass(JSConfetti, [
        {
            key: "loop",
            value: function loop() {
                this.requestAnimationFrameRequested = false;
                $45ffa6ee91549f09$var$fixDPR(this.canvas);
                var currentTime = new Date().getTime();
                var timeDelta = currentTime - this.lastUpdated;
                var canvasHeight = this.canvas.offsetHeight;
                var cleanupInvisibleShapes = this.iterationIndex % 10 === 0;
                this.activeConfettiBatches = this.activeConfettiBatches.filter(function(batch) {
                    batch.processShapes({
                        timeDelta: timeDelta,
                        currentTime: currentTime
                    }, canvasHeight, cleanupInvisibleShapes); // Do not remove invisible shapes on every iteration
                    if (!cleanupInvisibleShapes) return true;
                    return !batch.complete();
                });
                this.iterationIndex++;
                this.queueAnimationFrameIfNeeded(currentTime);
            }
        },
        {
            key: "queueAnimationFrameIfNeeded",
            value: function queueAnimationFrameIfNeeded(currentTime) {
                if (this.requestAnimationFrameRequested) // We already have a pended animation frame, so there is no more work
                return;
                if (this.activeConfettiBatches.length < 1) // No shapes to animate, so don't queue another frame
                return;
                this.requestAnimationFrameRequested = true; // Capture the last updated time for animation
                this.lastUpdated = currentTime || new Date().getTime();
                requestAnimationFrame(this.loop);
            }
        },
        {
            key: "addConfetti",
            value: function addConfetti() {
                var confettiConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var _normalizeConfettiCon = $45ffa6ee91549f09$var$normalizeConfettiConfig(confettiConfig), confettiRadius = _normalizeConfettiCon.confettiRadius, confettiNumber = _normalizeConfettiCon.confettiNumber, confettiColors = _normalizeConfettiCon.confettiColors, emojis = _normalizeConfettiCon.emojis, emojiSize = _normalizeConfettiCon.emojiSize; // Use the bounding rect rather tahn the canvas width / height, because
                // .width / .height are unset until a layout pass has been completed. Upon
                // confetti being immediately queued on a page load, this hasn't happened so
                // the default of 300x150 will be returned, causing an improper source point
                // for the confetti animation.
                var canvasRect = this.canvas.getBoundingClientRect();
                var canvasWidth = canvasRect.width;
                var canvasHeight = canvasRect.height;
                var yPosition = canvasHeight * 5 / 7;
                var leftConfettiPosition = {
                    x: 0,
                    y: yPosition
                };
                var rightConfettiPosition = {
                    x: canvasWidth,
                    y: yPosition
                };
                var confettiGroup = new $45ffa6ee91549f09$var$ConfettiBatch(this.canvasContext);
                for(var i = 0; i < confettiNumber / 2; i++){
                    var confettiOnTheRight = new $45ffa6ee91549f09$var$ConfettiShape({
                        initialPosition: leftConfettiPosition,
                        direction: "right",
                        confettiRadius: confettiRadius,
                        confettiColors: confettiColors,
                        confettiNumber: confettiNumber,
                        emojis: emojis,
                        emojiSize: emojiSize,
                        canvasWidth: canvasWidth
                    });
                    var confettiOnTheLeft = new $45ffa6ee91549f09$var$ConfettiShape({
                        initialPosition: rightConfettiPosition,
                        direction: "left",
                        confettiRadius: confettiRadius,
                        confettiColors: confettiColors,
                        confettiNumber: confettiNumber,
                        emojis: emojis,
                        emojiSize: emojiSize,
                        canvasWidth: canvasWidth
                    });
                    confettiGroup.addShapes(confettiOnTheRight, confettiOnTheLeft);
                }
                this.activeConfettiBatches.push(confettiGroup);
                this.queueAnimationFrameIfNeeded();
                return confettiGroup.getBatchCompletePromise();
            }
        },
        {
            key: "clearCanvas",
            value: function clearCanvas() {
                this.activeConfettiBatches = [];
            }
        },
        {
            key: "destroyCanvas",
            value: function destroyCanvas() {
                this.canvas.remove();
            }
        }
    ]);
    return JSConfetti;
}();
var $45ffa6ee91549f09$export$2e2bcd8739ae039 = $45ffa6ee91549f09$var$JSConfetti;


class $61df76b2c2873416$export$4b08aed5f1ec6952 {
    constructor(game){
        this.game = game;
        this.bindElements();
        this.attachEventListeners();
        this.initializeTheme();
        this.jsConfetti = new (0, $45ffa6ee91549f09$export$2e2bcd8739ae039)();
    }
    bindElements() {
        // Modal Elements
        this.modalOverlay = document.getElementById("modal-overlay");
        this.modalCloseButtons = document.querySelectorAll("#modal-close, .btn-close");
        this.modalWord = document.getElementById("modal-word");
        this.modalHintsUsed = document.getElementById("modal-hints-used");
        this.modalScoreGained = document.getElementById("modal-score-gained");
        this.modalStreak = document.getElementById("modal-streak");
        this.modalHighscore = document.getElementById("modal-highscore");
        this.modalTitle = document.getElementById("modal-title");
        this.modalMessage = document.getElementById("modal-message");
        // Instruction Modal Elements
        this.instructionModalOverlay = document.getElementById("instruction-modal-overlay");
        this.instructionsBtn = document.getElementById("instructions-btn");
        this.instructionCloseBtn = document.getElementById("instruction-close");
        // UI Elements
        this.currentScoreEl = document.getElementById("current-score");
        this.highScoreEl = document.getElementById("high-score");
        this.streakEl = document.getElementById("streak");
        this.lifetimeHintsUsedEl = document.getElementById("lifetime-hints-used");
        this.messageEl = document.getElementById("message");
        this.attemptsEl = document.getElementById("attempts");
        this.hintEl = document.getElementById("hint");
        this.categoryEl = document.getElementById("category");
        this.guessInput = document.getElementById("guess-input");
        this.guessHistory = document.getElementById("guess-history");
        // Toggle Elements
        this.accordionToggle = document.querySelector(".accordion-toggle");
        this.accordionContent = document.querySelector(".accordion-content");
        this.dropdownToggle = document.querySelector(".dropdown-toggle");
        this.dropdownContent = document.querySelector(".dropdown-content");
        // Theme Toggle
        this.themeToggle = document.getElementById("theme-toggle");
    }
    attachEventListeners() {
        // Close Modal Buttons
        this.modalCloseButtons.forEach((button)=>{
            button.addEventListener("click", ()=>this.closeModal());
        });
        // Instructions Modal Buttons
        this.instructionsBtn.addEventListener("click", ()=>this.openInstructionModal());
        this.instructionCloseBtn.addEventListener("click", ()=>this.closeInstructionModal());
        // Accordion Toggle
        this.accordionToggle.addEventListener("click", ()=>this.toggleAccordion());
        // Dropdown Toggle
        this.dropdownToggle.addEventListener("click", ()=>this.toggleDropdown());
        // Theme Toggle
        this.themeToggle.addEventListener("change", ()=>this.toggleTheme());
        // Window Resize
        window.addEventListener("resize", ()=>this.handleResize());
    }
    initializeTheme() {
        const storedTheme = (0, $91900f9c9606830c$export$bf2a15d34f3c441c).get((0, $0549f5aaef62b2d2$export$5aae9b6b3e0e7094).THEME, (0, $0549f5aaef62b2d2$export$ce0e5beb5efeb79).DARK);
        document.documentElement.setAttribute("data-theme", storedTheme);
        this.themeToggle.checked = storedTheme === (0, $0549f5aaef62b2d2$export$ce0e5beb5efeb79).DARK;
    }
    toggleTheme() {
        const newTheme = this.themeToggle.checked ? (0, $0549f5aaef62b2d2$export$ce0e5beb5efeb79).DARK : (0, $0549f5aaef62b2d2$export$ce0e5beb5efeb79).LIGHT;
        document.documentElement.setAttribute("data-theme", newTheme);
        (0, $91900f9c9606830c$export$bf2a15d34f3c441c).set((0, $0549f5aaef62b2d2$export$5aae9b6b3e0e7094).THEME, newTheme);
    }
    toggleAccordion() {
        if (this.accordionContent.classList.contains("expanded")) {
            this.accordionContent.classList.remove("expanded");
            this.accordionContent.classList.add("collapsed");
        } else {
            this.accordionContent.classList.remove("collapsed");
            this.accordionContent.classList.add("expanded");
        }
        this.accordionToggle.classList.toggle("active");
    }
    toggleDropdown() {
        if (this.dropdownContent.classList.contains("expanded")) {
            this.dropdownContent.classList.remove("expanded");
            this.dropdownContent.classList.add("collapsed");
        } else {
            this.dropdownContent.classList.remove("collapsed");
            this.dropdownContent.classList.add("expanded");
        }
        this.dropdownToggle.classList.toggle("active");
    }
    handleResize() {
        if (window.innerWidth > 768) {
            this.dropdownContent.classList.remove("expanded", "collapsed");
            this.accordionContent.classList.remove("expanded", "collapsed");
            this.accordionToggle.classList.remove("active");
            this.dropdownToggle.classList.remove("active");
        }
    }
    openInstructionModal() {
        this.instructionModalOverlay.style.display = "flex";
    }
    closeInstructionModal() {
        this.instructionModalOverlay.style.display = "none";
    }
    showModal(modalData) {
        this.modalOverlay.style.display = "flex";
        this.modalWord.innerHTML = `The word was: <span>${modalData.answer}</span> \u{1F3AF}`;
        if (modalData.gameWon) {
            this.modalHintsUsed.innerHTML = `You used <span>${modalData.hintsUsedCount}</span> hints. \u{1F9E0}`;
            this.modalScoreGained.innerHTML = `<span>${modalData.scoreIncrease}</span> points gained! \u{1F389}`;
            this.modalStreak.innerHTML = `You're on a <span>${modalData.streak}</span> ${modalData.streak === 1 ? "day" : "days"} streak! \u{1F31F}`;
            this.modalTitle.innerText = "Woohoo! \uD83C\uDF89";
            this.modalMessage.innerText = "Come back tomorrow for another puzzle!";
            this.jsConfetti.addConfetti();
        } else {
            this.modalHintsUsed.innerHTML = "";
            this.modalScoreGained.innerText = "Better luck next time!";
            this.modalStreak.innerText = "Your streak has been reset.";
            this.modalTitle.innerText = "Game Over!";
            this.modalMessage.innerText = "Come back tomorrow to try again on a new puzzle!";
        }
        this.modalHighscore.innerHTML = `High Score: <span>${modalData.highScore}</span>`;
    }
    closeModal() {
        this.modalOverlay.style.display = "none";
    }
    updateScoreboard({ currentScore: currentScore, highScore: highScore, streak: streak, lifetimeHintsUsed: lifetimeHintsUsed }) {
        this.currentScoreEl.innerText = currentScore;
        this.highScoreEl.innerText = highScore;
        this.streakEl.innerText = streak;
        this.lifetimeHintsUsedEl.innerText = lifetimeHintsUsed;
    }
    displayClues(clues) {
        document.getElementById("clue1").innerText = clues[0];
        document.getElementById("clue2").innerText = clues[1];
        document.getElementById("clue3").innerText = clues[2];
    }
    addGuessTile(guess, isCorrect) {
        const guessIndex = (0, $0549f5aaef62b2d2$export$da9ab7b2fd5998e8) - this.game.attemptsLeft + 1;
        const guessTile = document.createElement("div");
        guessTile.classList.add("guess-tile");
        guessTile.setAttribute("id", `guess${guessIndex}`);
        const icon = document.createElement("div");
        icon.classList.add("icon");
        icon.innerText = isCorrect ? "\u2714" : "\u2716";
        const guessText = document.createElement("div");
        guessText.classList.add("guess-text");
        guessText.innerText = guess;
        guessTile.appendChild(icon);
        guessTile.appendChild(guessText);
        if (isCorrect) {
            guessTile.classList.add("correct");
            this.displayMessage("Correct! Well done.", (0, $0549f5aaef62b2d2$export$e5fcfdba4a8ae715).SUCCESS);
        } else {
            guessTile.classList.add("incorrect");
            this.displayMessage("Incorrect guess. Try again!", (0, $0549f5aaef62b2d2$export$e5fcfdba4a8ae715).ERROR);
            this.updateAttemptsLeft(this.game.attemptsLeft);
        }
        this.guessHistory.appendChild(guessTile);
    }
    displayMessage(message, type) {
        switch(type){
            case (0, $0549f5aaef62b2d2$export$e5fcfdba4a8ae715).SUCCESS:
                this.messageEl.style.color = "#44bd32";
                break;
            case (0, $0549f5aaef62b2d2$export$e5fcfdba4a8ae715).ERROR:
                this.messageEl.style.color = "#e84118";
                break;
            case (0, $0549f5aaef62b2d2$export$e5fcfdba4a8ae715).INFO:
                this.messageEl.style.color = "#000";
                break;
            case (0, $0549f5aaef62b2d2$export$e5fcfdba4a8ae715).WARNING:
                this.messageEl.style.color = "#fbc531";
                break;
            default:
                this.messageEl.style.color = "#000";
        }
        this.messageEl.innerHTML = message;
    }
    updateAttemptsLeft(attemptsLeft) {
        this.attemptsEl.innerText = `Attempts left: ${attemptsLeft}`;
    }
    displayHint(hint) {
        this.hintEl.innerText = `\u{1F4A1} Hint: ${hint}`;
    }
    displayCategory(category) {
        this.categoryEl.innerText = `Category: ${category}`;
    }
    clearGuessInput() {
        this.guessInput.value = "";
        this.guessInput.focus();
    }
    disableInputs() {
        this.guessInput.disabled = true;
        document.querySelector(".btn-submit").disabled = true;
        document.querySelector(".btn-hint").disabled = true;
        document.querySelector(".btn-category").disabled = true;
        document.querySelector(".btn-skip").disabled = true;
    }
    enableInputs() {
        this.guessInput.disabled = false;
        document.querySelector(".btn-submit").disabled = false;
        document.querySelector(".btn-hint").disabled = false;
        document.querySelector(".btn-category").disabled = false;
        document.querySelector(".btn-skip").disabled = false;
    }
    showToast(message, type = (0, $0549f5aaef62b2d2$export$e5fcfdba4a8ae715).INFO) {
        switch(type){
            case (0, $0549f5aaef62b2d2$export$e5fcfdba4a8ae715).SUCCESS:
                break;
            case (0, $0549f5aaef62b2d2$export$e5fcfdba4a8ae715).ERROR:
                break;
            case (0, $0549f5aaef62b2d2$export$e5fcfdba4a8ae715).INFO:
                break;
            case (0, $0549f5aaef62b2d2$export$e5fcfdba4a8ae715).WARNING:
                break;
            default:
                break;
        }
    }
}


class $472cb95d11c6e757$export$985739bfa5723e08 {
    constructor(gameData){
        this.gameData = gameData; // Array of game objects
        this.ui = new (0, $61df76b2c2873416$export$4b08aed5f1ec6952)(this);
        this.initializeGame();
    }
    /*** Initialization ***/ initializeGame() {
        // Initialize game state from storage or set defaults
        this.currentMode = (0, $0549f5aaef62b2d2$export$d155b7b3d8e33c99).DAILY;
        this.attemptsLeft = (0, $0549f5aaef62b2d2$export$da9ab7b2fd5998e8);
        this.hintUsed = false;
        this.categoryRevealed = false;
        this.gameWon = false;
        this.hintsUsedCount = 0;
        this.lifetimeHintsUsed = parseInt((0, $91900f9c9606830c$export$bf2a15d34f3c441c).get((0, $0549f5aaef62b2d2$export$5aae9b6b3e0e7094).LIFETIME_HINTS, 0));
        this.scoreIncrease = 0;
        this.currentScore = parseInt((0, $91900f9c9606830c$export$bf2a15d34f3c441c).get((0, $0549f5aaef62b2d2$export$5aae9b6b3e0e7094).CURRENT_SCORE, 0));
        this.highScore = parseInt((0, $91900f9c9606830c$export$bf2a15d34f3c441c).get((0, $0549f5aaef62b2d2$export$5aae9b6b3e0e7094).HIGH_SCORE, 0));
        this.streak = parseInt((0, $91900f9c9606830c$export$bf2a15d34f3c441c).get((0, $0549f5aaef62b2d2$export$5aae9b6b3e0e7094).STREAK, 0));
        const now = new Date();
        const localMidnight = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
        this.todayDateString = new Date(localMidnight).toDateString();
        this.lastPlayed = (0, $91900f9c9606830c$export$bf2a15d34f3c441c).get((0, $0549f5aaef62b2d2$export$5aae9b6b3e0e7094).LAST_PLAYED, "");
        this.currentGame = {};
        // Bind UI event listeners
        this.bindUIActions();
        // Check first-time user
        this.checkFirstTimeUser();
        // Start the game
        this.startGame();
    }
    /*** UI Binding ***/ bindUIActions() {
        // Submit Guess
        document.querySelector(".btn-submit").addEventListener("click", ()=>this.submitGuess());
        // Show Hint
        document.querySelector(".btn-hint").addEventListener("click", ()=>this.showHint());
        // Reveal Category
        document.querySelector(".btn-category").addEventListener("click", ()=>this.revealCategory());
        // Switch to Daily Mode
        document.querySelector("#daily-mode-btn").addEventListener("click", ()=>this.switchMode((0, $0549f5aaef62b2d2$export$d155b7b3d8e33c99).DAILY));
        // Switch to Practice Mode
        document.querySelector("#practice-mode-btn").addEventListener("click", ()=>this.switchMode((0, $0549f5aaef62b2d2$export$d155b7b3d8e33c99).PRACTICE));
        // Skip or Give Up
        document.querySelector(".btn-skip").addEventListener("click", ()=>this.handleGiveUp());
        // Enter Key Submission
        this.ui.guessInput.addEventListener("keydown", (event)=>{
            if (event.key === "Enter") this.submitGuess();
        });
    }
    /*** User Onboarding ***/ checkFirstTimeUser() {
        if (!(0, $91900f9c9606830c$export$bf2a15d34f3c441c).get((0, $0549f5aaef62b2d2$export$5aae9b6b3e0e7094).FIRST_TIME)) {
            (0, $91900f9c9606830c$export$bf2a15d34f3c441c).set((0, $0549f5aaef62b2d2$export$5aae9b6b3e0e7094).FIRST_TIME, true);
            this.ui.openInstructionModal();
        }
    }
    /*** Game Start ***/ startGame() {
        this.updateScoreboard();
        if (this.currentMode === (0, $0549f5aaef62b2d2$export$d155b7b3d8e33c99).DAILY) {
            document.querySelector(".btn-skip").innerHTML = "Give Up";
            this.startDailyGame();
        } else {
            document.querySelector(".btn-skip").innerHTML = "Skip";
            this.startPracticeGame();
        }
        this.generateAndDisplayClues();
    }
    /*** Score Management ***/ updateScoreboard() {
        this.ui.updateScoreboard({
            currentScore: this.currentScore,
            highScore: this.highScore,
            streak: this.streak,
            lifetimeHintsUsed: this.lifetimeHintsUsed
        });
    }
    updateScore() {
        this.scoreIncrease = (this.attemptsLeft + 1) * 10 - this.hintsUsedCount * 5;
        this.scoreIncrease = Math.max(this.scoreIncrease, 0);
        this.currentScore += this.scoreIncrease;
        this.streak++;
        if (this.currentScore > this.highScore) {
            this.highScore = this.currentScore;
            (0, $91900f9c9606830c$export$bf2a15d34f3c441c).set((0, $0549f5aaef62b2d2$export$5aae9b6b3e0e7094).HIGH_SCORE, this.highScore);
        }
        this.ui.updateScoreboard({
            currentScore: this.currentScore,
            highScore: this.highScore,
            streak: this.streak,
            lifetimeHintsUsed: this.lifetimeHintsUsed
        });
        (0, $91900f9c9606830c$export$bf2a15d34f3c441c).set((0, $0549f5aaef62b2d2$export$5aae9b6b3e0e7094).CURRENT_SCORE, this.currentScore);
        (0, $91900f9c9606830c$export$bf2a15d34f3c441c).set((0, $0549f5aaef62b2d2$export$5aae9b6b3e0e7094).STREAK, this.streak);
    }
    resetStreak() {
        this.streak = 0;
        this.currentScore = 0;
        this.scoreIncrease = 0;
        this.ui.updateScoreboard({
            currentScore: this.currentScore,
            highScore: this.highScore,
            streak: this.streak,
            lifetimeHintsUsed: this.lifetimeHintsUsed
        });
        (0, $91900f9c9606830c$export$bf2a15d34f3c441c).set((0, $0549f5aaef62b2d2$export$5aae9b6b3e0e7094).STREAK, this.streak);
        (0, $91900f9c9606830c$export$bf2a15d34f3c441c).set((0, $0549f5aaef62b2d2$export$5aae9b6b3e0e7094).CURRENT_SCORE, this.currentScore);
    }
    /*** Game Mode Management ***/ switchMode(mode) {
        if (this.currentMode === mode) return;
        this.currentMode = mode;
        document.getElementById("daily-mode-btn").classList.remove("active");
        document.getElementById("practice-mode-btn").classList.remove("active");
        if (mode === (0, $0549f5aaef62b2d2$export$d155b7b3d8e33c99).DAILY) {
            document.getElementById("daily-mode-btn").classList.add("active");
            document.querySelector(".btn-skip").innerHTML = "Give Up";
            this.startGame();
        } else {
            document.getElementById("practice-mode-btn").classList.add("active");
            document.querySelector(".btn-skip").innerHTML = "Skip";
            this.startGame();
        }
    }
    /*** Game State Management - Practice Mode ***/ initializePracticeModeOrder() {
        const shuffledOrder = this.shuffleArray([
            ...Array(this.gameData.length).keys()
        ]);
        (0, $91900f9c9606830c$export$bf2a15d34f3c441c).set((0, $0549f5aaef62b2d2$export$5aae9b6b3e0e7094).PRACTICE_GAME_ORDER, shuffledOrder);
        (0, $91900f9c9606830c$export$bf2a15d34f3c441c).set((0, $0549f5aaef62b2d2$export$5aae9b6b3e0e7094).PRACTICE_GAME_INDEX, 0);
    }
    /**
     * @param {Array} array
     * @returns {Array}
     */ shuffleArray(array) {
        for(let i = array.length - 1; i > 0; i--){
            const j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [
                array[j],
                array[i]
            ];
        }
        return array;
    }
    startPracticeGame() {
        let shuffledOrder = (0, $91900f9c9606830c$export$bf2a15d34f3c441c).get((0, $0549f5aaef62b2d2$export$5aae9b6b3e0e7094).PRACTICE_GAME_ORDER, null);
        let currentIndex = parseInt((0, $91900f9c9606830c$export$bf2a15d34f3c441c).get((0, $0549f5aaef62b2d2$export$5aae9b6b3e0e7094).PRACTICE_GAME_INDEX, 0));
        // If no order exists or all games have been played, initialize/reset the order
        if (!shuffledOrder || currentIndex >= shuffledOrder.length) {
            this.initializePracticeModeOrder();
            shuffledOrder = (0, $91900f9c9606830c$export$bf2a15d34f3c441c).get((0, $0549f5aaef62b2d2$export$5aae9b6b3e0e7094).PRACTICE_GAME_ORDER, []);
            currentIndex = 0;
        }
        // Get the game index for the current practice session
        const gameIndex = shuffledOrder[currentIndex];
        this.currentGame = this.gameData[gameIndex];
        this.currentGame.answers = Array.isArray(this.currentGame.answers) ? this.currentGame.answers : [
            this.currentGame.answers
        ];
        // Increment the current index and update storage
        currentIndex++;
        (0, $91900f9c9606830c$export$bf2a15d34f3c441c).set((0, $0549f5aaef62b2d2$export$5aae9b6b3e0e7094).PRACTICE_GAME_INDEX, currentIndex);
        // Reset game state and display clues
        this.resetGameState();
        this.generateAndDisplayClues();
    }
    /*** Game State Management ***/ startDailyGame() {
        if (this.lastPlayed === this.todayDateString) this.loadSavedGame();
        else {
            this.resetGameState();
            this.generateAndDisplayClues();
            (0, $91900f9c9606830c$export$bf2a15d34f3c441c).set((0, $0549f5aaef62b2d2$export$5aae9b6b3e0e7094).LAST_PLAYED, this.todayDateString);
            (0, $91900f9c9606830c$export$bf2a15d34f3c441c).remove((0, $0549f5aaef62b2d2$export$5aae9b6b3e0e7094).GAME_STATE);
        }
    }
    resetGameState() {
        this.attemptsLeft = (0, $0549f5aaef62b2d2$export$da9ab7b2fd5998e8);
        this.hintUsed = false;
        this.categoryRevealed = false;
        this.gameWon = false;
        this.hintsUsedCount = 0;
        this.scoreIncrease = 0;
        // Clear UI elements
        this.ui.guessHistory.innerHTML = "";
        this.ui.messageEl.innerText = "";
        this.ui.attemptsEl.innerText = `Attempts left: ${this.attemptsLeft}`;
        this.ui.hintEl.innerText = "";
        this.ui.categoryEl.innerText = "";
        this.ui.guessInput.value = "";
        this.ui.enableInputs();
    }
    generateAndDisplayClues() {
        if (this.currentMode === (0, $0549f5aaef62b2d2$export$d155b7b3d8e33c99).DAILY) this.currentGame = this.generateDailyGame();
        else this.currentGame = this.generatePracticeGame();
        this.ui.displayClues(this.currentGame.clues);
    }
    generateDailyGame() {
        const now = new Date();
        const localMidnight = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
        const dayIndex = Math.floor(localMidnight / 86400000) % this.gameData.length;
        const selectedGame = this.gameData[dayIndex];
        selectedGame.answers = Array.isArray(selectedGame.answers) ? selectedGame.answers : [
            selectedGame.answers
        ];
        return selectedGame;
    }
    generatePracticeGame() {
        const randomIndex = Math.floor(Math.random() * this.gameData.length);
        const selectedGame = this.gameData[randomIndex];
        selectedGame.answers = Array.isArray(selectedGame.answers) ? selectedGame.answers : [
            selectedGame.answers
        ];
        return selectedGame;
    }
    saveGameState() {
        const gameState = {
            attemptsLeft: this.attemptsLeft,
            hintUsed: this.hintUsed,
            categoryRevealed: this.categoryRevealed,
            gameWon: this.gameWon,
            hintsUsedCount: this.hintsUsedCount,
            scoreIncrease: this.scoreIncrease,
            guessHistory: this.getGuessHistory(),
            answers: this.currentGame.answers
        };
        (0, $91900f9c9606830c$export$bf2a15d34f3c441c).set((0, $0549f5aaef62b2d2$export$5aae9b6b3e0e7094).GAME_STATE, gameState);
    }
    loadSavedGame() {
        const savedState = (0, $91900f9c9606830c$export$bf2a15d34f3c441c).get((0, $0549f5aaef62b2d2$export$5aae9b6b3e0e7094).GAME_STATE, null);
        if (savedState) {
            this.attemptsLeft = savedState.attemptsLeft;
            this.hintUsed = savedState.hintUsed;
            this.categoryRevealed = savedState.categoryRevealed;
            this.gameWon = savedState.gameWon;
            this.hintsUsedCount = savedState.hintsUsedCount || 0;
            this.scoreIncrease = savedState.scoreIncrease || 0;
            this.currentGame = this.generateDailyGame();
            this.currentGame.answers = savedState.answers || this.currentGame.answers;
            this.restoreGuessHistory(savedState.guessHistory);
            if (this.hintUsed) this.ui.displayHint(this.currentGame.hint);
            if (this.categoryRevealed || this.gameWon) this.ui.displayCategory(this.currentGame.category);
            if (this.attemptsLeft === 0 || this.gameWon) this.endGame();
            else {
                this.ui.displayMessage(savedState.message || "", (0, $0549f5aaef62b2d2$export$e5fcfdba4a8ae715).INFO);
                this.ui.updateAttemptsLeft(this.attemptsLeft);
                this.ui.enableInputs();
            }
        } else this.resetGameState();
    }
    restoreGuessHistory(guessHistory) {
        guessHistory.forEach((guessData, index)=>{
            const guessTile = document.createElement("div");
            guessTile.className = `guess-tile ${guessData.className}`;
            guessTile.id = `guess${index + 1}`;
            if (guessData.icon || guessData.guessText) {
                const icon = document.createElement("div");
                icon.classList.add("icon");
                icon.innerText = guessData.icon;
                const guessText = document.createElement("div");
                guessText.classList.add("guess-text");
                guessText.innerText = guessData.guessText;
                guessTile.appendChild(icon);
                guessTile.appendChild(guessText);
            }
            this.ui.guessHistory.appendChild(guessTile);
        });
    }
    getGuessHistory() {
        const guessTiles = document.querySelectorAll(".guess-tile");
        const guessHistory = [];
        guessTiles.forEach((tile)=>{
            const icon = tile.querySelector(".icon")?.innerText || "";
            const guessText = tile.querySelector(".guess-text")?.innerText || "";
            guessHistory.push({
                className: tile.className,
                icon: icon,
                guessText: guessText
            });
        });
        return guessHistory;
    }
    /*** Guess Handling ***/ normalizeString(str) {
        if (typeof str !== "string") {
            console.error("normalizeString received a non-string value:", str);
            return "";
        }
        return str.toLowerCase().normalize("NFD") // Normalize the string
        .replace(/[\u0300-\u036f]/g, "") // Remove diacritics
        .replace(/['’‘`´]/g, "") // Remove various apostrophe-like characters
        .replace(/[.,!?;:-_&@#%*()\[\]{}<>~`\\/]/g, "") // Remove additional punctuation and symbols
        .replace(/\s+/g, " ") // Replace multiple spaces with a single space
        .trim(); // Remove leading and trailing spaces
    }
    submitGuess() {
        const userGuess = this.ui.guessInput.value.trim();
        if (userGuess.length === 0) {
            this.ui.showToast("Please enter a guess.", (0, $0549f5aaef62b2d2$export$e5fcfdba4a8ae715).WARNING);
            return;
        }
        const normalizedUserGuess = this.normalizeString(userGuess);
        const normalizedAnswers = this.currentGame.answers.map((answer)=>this.normalizeString(answer));
        this.attemptsLeft--;
        if (normalizedAnswers.includes(normalizedUserGuess)) this.handleCorrectGuess();
        else this.handleIncorrectGuess();
        if (this.currentMode === (0, $0549f5aaef62b2d2$export$d155b7b3d8e33c99).DAILY) this.saveGameState();
        this.ui.updateAttemptsLeft(this.attemptsLeft);
        this.ui.clearGuessInput();
    }
    handleCorrectGuess() {
        this.gameWon = true;
        this.ui.addGuessTile(this.ui.guessInput.value.trim(), true);
        if (this.currentMode === (0, $0549f5aaef62b2d2$export$d155b7b3d8e33c99).DAILY) this.updateScore();
        this.endGame();
    }
    handleIncorrectGuess() {
        this.ui.addGuessTile(this.ui.guessInput.value.trim(), false);
        if (this.attemptsLeft > 0) this.ui.displayMessage("Incorrect guess. Try again!", (0, $0549f5aaef62b2d2$export$e5fcfdba4a8ae715).ERROR);
        if (this.attemptsLeft === 0) {
            this.ui.displayMessage("No attempts left. Game Over!", (0, $0549f5aaef62b2d2$export$e5fcfdba4a8ae715).ERROR);
            this.endGame();
            this.resetStreak();
        }
    }
    /*** Hint and Category ***/ showHint() {
        if (!this.hintUsed) {
            this.ui.displayHint(this.currentGame.hint);
            this.hintUsed = true;
            if (this.currentMode === (0, $0549f5aaef62b2d2$export$d155b7b3d8e33c99).DAILY) {
                this.hintsUsedCount++;
                this.lifetimeHintsUsed++;
                this.ui.updateScoreboard({
                    currentScore: this.currentScore,
                    highScore: this.highScore,
                    streak: this.streak,
                    lifetimeHintsUsed: this.lifetimeHintsUsed
                });
                (0, $91900f9c9606830c$export$bf2a15d34f3c441c).set((0, $0549f5aaef62b2d2$export$5aae9b6b3e0e7094).LIFETIME_HINTS, this.lifetimeHintsUsed);
                this.saveGameState();
            }
        } else this.ui.showToast("You have already used the hint for this round.", (0, $0549f5aaef62b2d2$export$e5fcfdba4a8ae715).INFO);
    }
    revealCategory() {
        if (!this.categoryRevealed) {
            this.ui.displayCategory(this.currentGame.category);
            this.categoryRevealed = true;
            if (this.currentMode === (0, $0549f5aaef62b2d2$export$d155b7b3d8e33c99).DAILY) {
                this.hintsUsedCount++;
                this.lifetimeHintsUsed++;
                this.ui.updateScoreboard({
                    currentScore: this.currentScore,
                    highScore: this.highScore,
                    streak: this.streak,
                    lifetimeHintsUsed: this.lifetimeHintsUsed
                });
                (0, $91900f9c9606830c$export$bf2a15d34f3c441c).set((0, $0549f5aaef62b2d2$export$5aae9b6b3e0e7094).LIFETIME_HINTS, this.lifetimeHintsUsed);
                this.saveGameState();
            }
        } else this.ui.showToast("The category is already revealed.", (0, $0549f5aaef62b2d2$export$e5fcfdba4a8ae715).INFO);
    }
    /*** Game End Handling ***/ endGame() {
        this.ui.disableInputs();
        if (this.currentMode === (0, $0549f5aaef62b2d2$export$d155b7b3d8e33c99).PRACTICE) {
            this.ui.displayMessage(this.gameWon ? `Woohoo! The correct answer was: <strong>${this.currentGame.answers[0]}</strong>` : `Better luck next time! The correct answer was: <strong>${this.currentGame.answers[0]}</strong>`, this.gameWon ? (0, $0549f5aaef62b2d2$export$e5fcfdba4a8ae715).SUCCESS : (0, $0549f5aaef62b2d2$export$e5fcfdba4a8ae715).ERROR);
            setTimeout(()=>{
                this.startPracticeGame();
            }, 3000);
        } else this.showModal();
    }
    handleGiveUp() {
        this.attemptsLeft = 0;
        this.ui.updateAttemptsLeft(this.attemptsLeft);
        if (this.currentMode === (0, $0549f5aaef62b2d2$export$d155b7b3d8e33c99).DAILY) {
            this.gameWon = false;
            this.resetStreak();
            this.saveGameState();
        }
        this.endGame();
    }
    showModal() {
        if (this.currentMode === (0, $0549f5aaef62b2d2$export$d155b7b3d8e33c99).PRACTICE) return;
        const modalData = {
            gameWon: this.gameWon,
            answer: this.currentGame.answers[0],
            hint: this.currentGame.hint,
            category: this.currentGame.category,
            hintsUsedCount: this.hintsUsedCount,
            scoreIncrease: this.scoreIncrease,
            streak: this.streak,
            highScore: this.highScore
        };
        this.ui.showModal(modalData);
    }
}


const $59cc4cc8e38f3e25$export$b770c311badf26d4 = [
    {
        category: "Technology",
        clues: [
            "Search",
            "Browser",
            "Ads"
        ],
        answers: [
            "Google",
            "Google Search",
            "Google Chrome"
        ],
        hint: "You probably say its name when you need to look something up."
    },
    {
        category: "Animals",
        clues: [
            "Stripes",
            "Horse-like",
            "Black and white"
        ],
        answers: [
            "Zebra"
        ],
        hint: "It looks like a horse but wears stripes."
    },
    {
        category: "Food",
        clues: [
            "Tropical",
            "Yellow",
            "Curved"
        ],
        answers: [
            "Banana"
        ],
        hint: "This fruit comes in bunches and is easy to peel."
    },
    {
        category: "Movies",
        clues: [
            "Wizard",
            "Scar",
            "Magic"
        ],
        answers: [
            "Harry Potter"
        ],
        hint: "He\u2019s the kid with a scar who goes to a magical school."
    },
    {
        category: "Geography",
        clues: [
            "Island",
            "Kangaroos",
            "Outback"
        ],
        answers: [
            "Australia"
        ],
        hint: "This place is famous for kangaroos and the Outback."
    },
    {
        category: "Sports",
        clues: [
            "Court",
            "Ball",
            "Net"
        ],
        answers: [
            "Basketball"
        ],
        hint: "You\u2019ll see people dribbling and shooting hoops in this game."
    },
    {
        category: "Music",
        clues: [
            "King",
            "Rock",
            "Graceland"
        ],
        answers: [
            "Elvis Presley"
        ],
        hint: "He\u2019s the guy who shook his hips and sang \u2018Hound Dog.\u2019"
    },
    {
        category: "Literature",
        clues: [
            "Whale",
            "Sea",
            "Ahab"
        ],
        answers: [
            "Moby Dick"
        ],
        hint: "A captain spends the whole story chasing a big white whale."
    },
    {
        category: "Technology",
        clues: [
            "Photos",
            "Social",
            "Stories"
        ],
        answers: [
            "Instagram"
        ],
        hint: "People post their best photos here for likes."
    },
    {
        category: "Animals",
        clues: [
            "Jungle",
            "King",
            "Mane"
        ],
        answers: [
            "Lion"
        ],
        hint: "This big cat is often called the king of the jungle."
    },
    {
        category: "Food",
        clues: [
            "Red",
            "Sauce",
            "Cheese"
        ],
        answers: [
            "Pizza"
        ],
        hint: "Often chosen for sharing with friends."
    },
    {
        category: "Movies",
        clues: [
            "Ship",
            "Iceberg",
            "Romance"
        ],
        answers: [
            "Titanic"
        ],
        hint: "Its name is remembered for a famous misfortune."
    },
    {
        category: "Geography",
        clues: [
            "Pyramids",
            "Desert",
            "Pharaohs"
        ],
        answers: [
            "Egypt"
        ],
        hint: "Known for structures that have stood for thousands of years."
    },
    {
        category: "Sports",
        clues: [
            "Field",
            "Goal",
            "Team"
        ],
        answers: [
            "Soccer, Football"
        ],
        hint: "It\u2019s played with feet, not hands."
    },
    {
        category: "Literature",
        clues: [
            "Ring",
            "Journey",
            "Middle Earth"
        ],
        answers: [
            "Lord of the Rings",
            "The Lord of the Rings",
            "LOTR",
            "Lord of the Ring",
            "The Lord of the Ring",
            "The LOTR",
            "The Hobbit"
        ],
        hint: "A journey with a group set to destroy something powerful."
    },
    {
        category: "Technology",
        clues: [
            "Videos",
            "Subscribers",
            "Channels"
        ],
        answers: [
            "YouTube"
        ],
        hint: "A place where people watch and upload videos."
    },
    {
        category: "Animals",
        clues: [
            "Aquatic",
            "Fins",
            "Predator"
        ],
        answers: [
            "Shark"
        ],
        hint: "Recognized by its iconic fin cutting through water."
    },
    {
        category: "Food",
        clues: [
            "Mexican",
            "Tortilla",
            "Folded"
        ],
        answers: [
            "Taco"
        ],
        hint: "Folded but never crumpled."
    },
    {
        category: "Movies",
        clues: [
            "Space",
            "Force",
            "Galaxy"
        ],
        answers: [
            "Star Wars"
        ],
        hint: "A battle between light and dark, set in the stars."
    },
    {
        category: "Geography",
        clues: [
            "Eiffel Tower",
            "Paris",
            "Wine"
        ],
        answers: [
            "France"
        ],
        hint: "This place is home to a tower that\u2019s hard to miss."
    },
    {
        category: "Sports",
        clues: [
            "Racket",
            "Net",
            "Serve"
        ],
        answers: [
            "Tennis"
        ],
        hint: "A fast-paced game played by millions around the world."
    },
    {
        category: "Music",
        clues: [
            "Fab Four",
            "Liverpool",
            "British"
        ],
        answers: [
            "The Beatles"
        ],
        hint: "Famous for changing the sound of the 60s."
    },
    {
        category: "Literature",
        clues: [
            "Dystopia",
            "Big Brother",
            "Surveillance"
        ],
        answers: [
            "1984"
        ],
        hint: "A story about a world where everyone is being watched."
    },
    {
        category: "Technology",
        clues: [
            "Smartphone",
            "Apps",
            "iOS"
        ],
        answers: [
            "Apple"
        ],
        hint: "A tech giant known for sleek gadgets and devices."
    },
    {
        category: "Animals",
        clues: [
            "Mammal",
            "Ocean",
            "Whale"
        ],
        answers: [
            "Dolphin"
        ],
        hint: "A playful ocean animal often seen in groups."
    },
    {
        category: "Food",
        clues: [
            "Italian",
            "Pasta",
            "Cheese"
        ],
        answers: [
            "Lasagna"
        ],
        hint: "This dish is known for its layers of comfort."
    },
    {
        category: "Movies",
        clues: [
            "Superhero",
            "Avengers",
            "Hammer"
        ],
        answers: [
            "Thor"
        ],
        hint: "Wields something that\u2019s impossible for most to lift."
    },
    {
        category: "Geography",
        clues: [
            "Mountain",
            "Cold",
            "Everest"
        ],
        answers: [
            "Himalayas"
        ],
        hint: "The roof of the world."
    },
    {
        category: "Music",
        clues: [
            "Country",
            "Guitar",
            "Tennessee"
        ],
        answers: [
            "Johnny Cash"
        ],
        hint: "His voice matched the color of his clothes."
    },
    {
        category: "Literature",
        clues: [
            "Fantasy",
            "Dragons",
            "Throne"
        ],
        answers: [
            "Game of Thrones"
        ],
        hint: "A story where many fight for one seat."
    },
    {
        category: "Technology",
        clues: [
            "Streaming",
            "Shows",
            "Movies"
        ],
        answers: [
            "Netflix"
        ],
        hint: "This place is known for its 'binge-worthy' offerings."
    },
    {
        category: "Geography",
        clues: [
            "Rainforest",
            "River",
            "South America"
        ],
        answers: [
            "Amazon",
            "Amazon Rainforest"
        ],
        hint: "Spanning vast lands, this place is known for its richness in life."
    },
    {
        category: "Technology",
        clues: [
            "Text",
            "Messaging",
            "Blue Bubbles"
        ],
        answers: [
            "iMessage",
            "Apple iMessage",
            "Messages",
            "Apple Messages"
        ],
        hint: "Famous for making communication a bit 'blue.'"
    },
    {
        category: "Animals",
        clues: [
            "Marsupial",
            "Australia",
            "Pouch"
        ],
        answers: [
            "Kangaroo"
        ],
        hint: "Jumps higher than most and carries its young along."
    },
    {
        category: "Food",
        clues: [
            "Breakfast",
            "Fluffy",
            "Syrup"
        ],
        answers: [
            "Pancakes"
        ],
        hint: "Often flipped before being stacked."
    },
    {
        category: "Movies",
        clues: [
            "Dinosaurs",
            "Island",
            "Park"
        ],
        answers: [
            "Jurassic Park"
        ],
        hint: "An island where old meets new in unexpected ways."
    },
    {
        category: "Geography",
        clues: [
            "Desert",
            "Pyramids",
            "Sphinx"
        ],
        answers: [
            "Egypt"
        ],
        hint: "Famous for its ancient wonders and historical rulers."
    },
    {
        category: "Sports",
        clues: [
            "Puck",
            "Ice",
            "Stick"
        ],
        answers: [
            "Hockey"
        ],
        hint: "Fast-paced and often ends in a 'shootout.'"
    },
    {
        category: "Music",
        clues: [
            "Rap",
            "8 Mile",
            "Detroit"
        ],
        answers: [
            "Eminem"
        ],
        hint: "Famous for lyrics that come fast and with meaning."
    },
    {
        category: "Literature",
        clues: [
            "Detective",
            "Pipe",
            "London"
        ],
        answers: [
            "Sherlock Holmes"
        ],
        hint: "A master at seeing what others miss."
    },
    {
        category: "Technology",
        clues: [
            "Photos",
            "Filters",
            "Square"
        ],
        answers: [
            "Instagram"
        ],
        hint: "Pictures are worth a thousand words, especially here."
    },
    {
        category: "Animals",
        clues: [
            "Long Neck",
            "Africa",
            "Tall"
        ],
        answers: [
            "Giraffe"
        ],
        hint: "Looks down on most due to its height."
    },
    {
        category: "Food",
        clues: [
            "Dairy",
            "Frozen",
            "Dessert"
        ],
        answers: [
            "Ice Cream"
        ],
        hint: "Best served cold, and often enjoyed when it\u2019s warm."
    },
    {
        category: "Movies",
        clues: [
            "Adventure",
            "Treasure",
            "Whip"
        ],
        answers: [
            "Indiana Jones"
        ],
        hint: "Known for always retrieving what was thought to be lost."
    },
    {
        category: "Geography",
        clues: [
            "Big Apple",
            "Empire State",
            "Statue of Liberty"
        ],
        answers: [
            "New York"
        ],
        hint: "The city that never sleeps."
    },
    {
        category: "Sports",
        clues: [
            "Field",
            "Bat",
            "Home Run"
        ],
        answers: [
            "Baseball"
        ],
        hint: "A game where people aim to make it back to where they started."
    },
    {
        category: "Music",
        clues: [
            "Purple",
            "Paisley Park",
            "Guitar"
        ],
        answers: [
            "Prince"
        ],
        hint: "Famous for a color and for making waves in music."
    },
    {
        category: "Literature",
        clues: [
            "Ring",
            "Gollum",
            "Hobbits"
        ],
        answers: [
            "Lord of the Rings",
            "The Lord of the Rings",
            "LOTR",
            "Lord of the Ring",
            "The Lord of the Ring",
            "The LOTR",
            "The Hobbit"
        ],
        hint: "A journey with a powerful item at its core."
    },
    {
        category: "Technology",
        clues: [
            "Video",
            "Streaming",
            "Subscription"
        ],
        answers: [
            "Netflix"
        ],
        hint: "The place to go to watch shows and movies online."
    },
    {
        category: "Animals",
        clues: [
            "Nocturnal",
            "Wings",
            "Vampire"
        ],
        answers: [
            "Bat"
        ],
        hint: "This flying creature is often seen at night."
    },
    {
        category: "Geography",
        clues: [
            "South America",
            "Soccer",
            "Carnival"
        ],
        answers: [
            "Brazil"
        ],
        hint: "Known for its vibrant celebrations and rhythm."
    },
    {
        category: "Sports",
        clues: [
            "Court",
            "Net",
            "Volleys"
        ],
        answers: [
            "Tennis"
        ],
        hint: "A fast-paced game played by millions around the world."
    },
    {
        category: "Music",
        clues: [
            "Thriller",
            "Glove",
            "Moonwalk"
        ],
        answers: [
            "Michael Jackson"
        ],
        hint: "A legend on stage, remembered for a certain move."
    },
    {
        category: "Literature",
        clues: [
            "Witches",
            "Flying Monkeys",
            "Yellow Brick Road"
        ],
        answers: [
            "The Wizard of Oz"
        ],
        hint: "Followed a road that led to an unexpected revelation."
    },
    {
        category: "Technology",
        clues: [
            "Work",
            "Microsoft",
            "Documents"
        ],
        answers: [
            "Microsoft Office",
            "Office",
            "MS Office",
            "Microsoft Word",
            "Word",
            "Microsoft Excel",
            "Excel",
            "Microsoft PowerPoint",
            "PowerPoint"
        ],
        hint: "A toolkit often opened when there\u2019s work to be done."
    },
    {
        category: "Animals",
        clues: [
            "Black and White",
            "Bamboo",
            "China"
        ],
        answers: [
            "Panda"
        ],
        hint: "A gentle giant with a unique diet."
    },
    {
        category: "Food",
        clues: [
            "Mexican",
            "Spicy",
            "Wrapped"
        ],
        answers: [
            "Burrito"
        ],
        hint: "It\u2019s wrapped but never boxed."
    },
    {
        category: "Movies",
        clues: [
            "Boxing",
            "Philadelphia",
            "Underdog"
        ],
        answers: [
            "Rocky",
            "Rocky Balboa"
        ],
        hint: "Started from the bottom but fought his way to the top."
    },
    {
        category: "Geography",
        clues: [
            "Ice",
            "Volcanoes",
            "Northern Lights"
        ],
        answers: [
            "Iceland"
        ],
        hint: "Where fire and ice coexist."
    },
    {
        category: "Sports",
        clues: [
            "Race",
            "Lanes",
            "Fast"
        ],
        answers: [
            "Running",
            "Sprinting",
            "Sprint",
            "Track and Field",
            "Track",
            "Field",
            "Track & Field"
        ],
        hint: "An activity where speed and endurance go hand in hand."
    },
    {
        category: "Music",
        clues: [
            "Fab Four",
            "Liverpool",
            "British"
        ],
        answers: [
            "The Beatles",
            "Beatles"
        ],
        hint: "A group from the UK that made a huge impact on music."
    },
    {
        category: "Literature",
        clues: [
            "Magic",
            "School",
            "Wand"
        ],
        answers: [
            "Harry Potter"
        ],
        hint: "A young hero destined for greatness."
    },
    {
        category: "Technology",
        clues: [
            "Video",
            "Streaming",
            "Google"
        ],
        answers: [
            "YouTube"
        ],
        hint: "A platform for watching and sharing videos."
    },
    {
        category: "Animals",
        clues: [
            "Tropical",
            "Colorful",
            "Bird"
        ],
        answers: [
            "Parrot"
        ],
        hint: "A bird known for its bright colors and ability to mimic sounds."
    },
    {
        category: "Food",
        clues: [
            "Grill",
            "Cheese",
            "Bread"
        ],
        answers: [
            "Grilled Cheese",
            "Grilled Cheese Sandwich"
        ],
        hint: "Simple, warm, and always satisfying."
    },
    {
        category: "Movies",
        clues: [
            "Superhero",
            "Marvel",
            "Iron Man"
        ],
        answers: [
            "The Avengers",
            "Avengers"
        ],
        hint: "A team of heroes coming together to save the day."
    },
    {
        category: "Geography",
        clues: [
            "Big Ben",
            "Tea",
            "Royal Family"
        ],
        answers: [
            "United Kingdom",
            "UK",
            "England",
            "Great Britain"
        ],
        hint: "A place with a long-standing monarchy."
    },
    {
        category: "Sports",
        clues: [
            "Pool",
            "Stick",
            "Balls"
        ],
        answers: [
            "Billiards",
            "Pool"
        ],
        hint: "A game played with precision and a steady hand."
    },
    {
        category: "Music",
        clues: [
            "Piano",
            "Rocket Man",
            "British"
        ],
        answers: [
            "Elton John"
        ],
        hint: "A star known for flashy outfits and classic tunes."
    },
    {
        category: "Literature",
        clues: [
            "Shakespeare",
            "Love",
            "Tragedy"
        ],
        answers: [
            "Romeo and Juliet",
            "Romeo & Juliet"
        ],
        hint: "A tale of love that\u2019s anything but simple."
    },
    {
        category: "Technology",
        clues: [
            "Shopping",
            "Online",
            "Delivery"
        ],
        answers: [
            "Amazon"
        ],
        hint: "From books to just about everything, this place delivers."
    },
    {
        category: "Animals",
        clues: [
            "Wool",
            "Farm",
            "Flock"
        ],
        answers: [
            "Sheep",
            "Lamb"
        ],
        hint: "Famous for following the herd."
    },
    {
        category: "Food",
        clues: [
            "Dough",
            "Sweet",
            "Icing"
        ],
        answers: [
            "Donut",
            "Doughnut"
        ],
        hint: "A circular treat with a hole in the middle."
    },
    {
        category: "Movies",
        clues: [
            "Robot",
            "Future",
            "Skynet"
        ],
        answers: [
            "Terminator",
            "The Terminator"
        ],
        hint: "Sent from the future to change the past."
    },
    {
        category: "Geography",
        clues: [
            "Wall",
            "Forbidden City",
            "Dragon"
        ],
        answers: [
            "China",
            "People's Republic of China",
            "PRC"
        ],
        hint: "Known for a long wall and a rich history."
    },
    {
        category: "Music",
        clues: [
            "Pop",
            "Moonwalk",
            "King"
        ],
        answers: [
            "Michael Jackson"
        ],
        hint: "A global star known for his dance moves and hit songs."
    },
    {
        category: "Technology",
        clues: [
            "Electric",
            "Autopilot",
            "Charging"
        ],
        answers: [
            "Tesla",
            "Tesla Motors"
        ],
        hint: "Known for revolutionizing how we move without using gas."
    },
    {
        category: "Animals",
        clues: [
            "Slow",
            "Shell",
            "Reptile"
        ],
        answers: [
            "Turtle",
            "Tortoise",
            "Sea Turtle"
        ],
        hint: "This creature carries its home on its back."
    },
    {
        category: "Food",
        clues: [
            "Sweet",
            "Fruit",
            "Pie"
        ],
        answers: [
            "Apple",
            "Apple Pie"
        ],
        hint: "Often paired with a teacher as a gift."
    },
    {
        category: "Movies",
        clues: [
            "Supernatural",
            "Kid",
            "Ghost"
        ],
        answers: [
            "The Sixth Sense",
            "Sixth Sense"
        ],
        hint: "A story where seeing isn\u2019t always believing."
    },
    {
        category: "Geography",
        clues: [
            "Snow",
            "Cold",
            "Loonie"
        ],
        answers: [
            "Canada"
        ],
        hint: "Known for its polite people and chilly winters."
    },
    {
        category: "Sports",
        clues: [
            "Helmet",
            "Touchdown",
            "Field"
        ],
        answers: [
            "Football",
            "American Football"
        ],
        hint: "A game where players wear helmets and aim to reach the end zone."
    },
    {
        category: "Music",
        clues: [
            "Jazz",
            "Trumpet",
            "New Orleans"
        ],
        answers: [
            "Louis Armstrong"
        ],
        hint: "A legendary musician known for his gravelly voice and trumpet."
    },
    {
        category: "Literature",
        clues: [
            "Adventure",
            "Pirate",
            "Treasure"
        ],
        answers: [
            "Treasure Island"
        ],
        hint: "A tale of pirates and a hidden fortune."
    },
    {
        category: "Technology",
        clues: [
            "Smart",
            "Portable",
            "Touchscreen"
        ],
        answers: [
            "Smartphone",
            "Smart Phone",
            "iPhone",
            "Android",
            "Samsung",
            "Google Pixel",
            "Phone"
        ],
        hint: "Almost everyone carries one in their pocket."
    },
    {
        category: "Animals",
        clues: [
            "Furry",
            "Tree",
            "Claws"
        ],
        answers: [
            "Koala"
        ],
        hint: "This cuddly creature spends most of its time sleeping in trees."
    },
    {
        category: "Technology",
        clues: [
            "Portable",
            "Music",
            "Clickwheel"
        ],
        answers: [
            "iPod"
        ],
        hint: "Revolutionized how people listened to music on the go."
    },
    {
        category: "Animals",
        clues: [
            "Echo",
            "Blind",
            "Night"
        ],
        answers: [
            "Bat"
        ],
        hint: "Navigates using sound in the dark."
    },
    {
        category: "Food",
        clues: [
            "Green",
            "Spread",
            "Toast"
        ],
        answers: [
            "Avocado"
        ],
        hint: "Often used as a trendy topping in breakfast dishes."
    },
    {
        category: "Movies",
        clues: [
            "Adventure",
            "Whip",
            "Archaeologist"
        ],
        answers: [
            "Indiana Jones"
        ],
        hint: "Known for retrieving ancient artifacts and wearing a fedora."
    },
    {
        category: "Sports",
        clues: [
            "Fast",
            "Track",
            "Relay"
        ],
        answers: [
            "Sprint",
            "Running",
            "Track and Field",
            "Track",
            "Field",
            "Track & Field"
        ],
        hint: "The shortest race, but requires the most speed."
    },
    {
        category: "Music",
        clues: [
            "Opera",
            "Mask",
            "Chandelier"
        ],
        answers: [
            "The Phantom of the Opera",
            "Phantom of the Opera"
        ],
        hint: "A haunting story set in a Parisian theater."
    },
    {
        category: "Literature",
        clues: [
            "Rebellion",
            "Dystopia",
            "Districts"
        ],
        answers: [
            "The Hunger Games",
            "Hunger Games"
        ],
        hint: "A dangerous competition is held every year in this world."
    },
    {
        category: "Technology",
        clues: [
            "Photos",
            "Memories",
            "Square Prints"
        ],
        answers: [
            "Polaroid",
            "Polaroid Camera",
            "Instant Camera",
            "Instant Film"
        ],
        hint: "Instantly develops what you capture."
    },
    {
        category: "Animals",
        clues: [
            "Stripes",
            "Endangered",
            "Big Cat"
        ],
        answers: [
            "Tiger"
        ],
        hint: "Known for its unique orange coat and black stripes."
    },
    {
        category: "Technology",
        clues: [
            "Streaming",
            "Music",
            "Subscription"
        ],
        answers: [
            "Spotify"
        ],
        hint: "Gave people access to millions of songs on demand."
    },
    {
        category: "Animals",
        clues: [
            "Insect",
            "Colony",
            "Queen"
        ],
        answers: [
            "Ant",
            "Ants"
        ],
        hint: "Known for its teamwork and complex underground homes."
    },
    {
        category: "Food",
        clues: [
            "Layered",
            "Crisp",
            "Chocolate"
        ],
        answers: [
            "KitKat"
        ],
        hint: "A treat known for snapping apart into pieces."
    },
    {
        category: "Movies",
        clues: [
            "Dream",
            "Heist",
            "Spinning Top"
        ],
        answers: [
            "Inception"
        ],
        hint: "A story where reality is often questioned."
    },
    {
        category: "Geography",
        clues: [
            "Capital",
            "Mount Fuji",
            "Island"
        ],
        answers: [
            "Japan"
        ],
        hint: "This island nation is known for its technology and tradition."
    },
    {
        category: "Sports",
        clues: [
            "Racket",
            "Shuttlecock",
            "Net"
        ],
        answers: [
            "Badminton"
        ],
        hint: "A fast-paced game where a lightweight object is hit over the net."
    },
    {
        category: "Music",
        clues: [
            "Reggae",
            "Jamaica",
            "Dreadlocks"
        ],
        answers: [
            "Bob Marley"
        ],
        hint: "An artist whose message of peace and love spread worldwide."
    },
    {
        category: "Literature",
        clues: [
            "Orphan",
            "Boarding School",
            "Wand"
        ],
        answers: [
            "Harry Potter"
        ],
        hint: "This boy wizard faced many challenges at a magical school."
    },
    {
        category: "Animals",
        clues: [
            "Aquatic",
            "Translucent",
            "Tentacles"
        ],
        answers: [
            "Jellyfish",
            "Jelly Fish"
        ],
        hint: "This creature drifts in the ocean and has a sting you want to avoid."
    },
    {
        category: "Technology",
        clues: [
            "Cloud",
            "Storage",
            "Photos"
        ],
        answers: [
            "Dropbox",
            "Drop Box"
        ],
        hint: "A place to keep your files safe and accessible online."
    },
    {
        category: "Animals",
        clues: [
            "Small",
            "Pouch",
            "Nocturnal"
        ],
        answers: [
            "Opossum"
        ],
        hint: "This animal plays dead to avoid danger."
    },
    {
        category: "Food",
        clues: [
            "Sweet",
            "Layers",
            "Party"
        ],
        answers: [
            "Cake",
            "Birthday Cake",
            "Wedding Cake",
            "Layer Cake",
            "Cupcake"
        ],
        hint: "Often the center of celebrations and birthdays."
    },
    {
        category: "Movies",
        clues: [
            "Adventure",
            "Aztec Gold",
            "Pirates"
        ],
        answers: [
            "Pirates of the Caribbean",
            "POTC"
        ],
        hint: "A swashbuckling adventure on the high seas."
    },
    {
        category: "Geography",
        clues: [
            "Island",
            "Pacific",
            "Volcano"
        ],
        answers: [
            "Hawaii",
            "Hawai'i"
        ],
        hint: "A tropical paradise known for surfing and active volcanoes."
    },
    {
        category: "Sports",
        clues: [
            "Race",
            "Fast",
            "Cars"
        ],
        answers: [
            "Formula 1",
            "F1"
        ],
        hint: "High-speed vehicles race on circuits around the world."
    },
    {
        category: "Music",
        clues: [
            "Guitar",
            "Legend",
            "Purple"
        ],
        answers: [
            "Prince"
        ],
        hint: "Known for his groundbreaking music and an affinity for a certain color."
    },
    {
        category: "Literature",
        clues: [
            "Magic",
            "Beast",
            "Fairy Tale"
        ],
        answers: [
            "Beauty and the Beast",
            "Beauty & the Beast"
        ],
        hint: "A tale about finding love beyond appearances."
    },
    {
        category: "Animals",
        clues: [
            "Scales",
            "Desert",
            "Tongue"
        ],
        answers: [
            "Lizard",
            "Gecko"
        ],
        hint: "This cold-blooded creature is often seen sunbathing on rocks."
    },
    {
        category: "Animals",
        clues: [
            "Fast",
            "Savanna",
            "Spots"
        ],
        answers: [
            "Cheetah",
            "Leopard"
        ],
        hint: "The fastest land animal, known for its speed and agility."
    },
    {
        category: "Literature",
        clues: [
            "Adventure",
            "Boy",
            "Fairy"
        ],
        answers: [
            "Peter Pan",
            "Peterpan"
        ],
        hint: "A classic tale of a boy who never grows up."
    },
    {
        category: "Music",
        clues: [
            "Compton",
            "Producer",
            "West Coast"
        ],
        answers: [
            "Dr. Dre"
        ],
        hint: "Discovered Eminem and Snoop Dogg and is the co-founder of Beats."
    },
    {
        category: "Geography",
        clues: [
            "Mountains",
            "Pasta",
            "Colosseum"
        ],
        answers: [
            "Italy",
            "Italia"
        ],
        hint: "A country known for its cuisine and ancient history."
    },
    {
        category: "Food",
        clues: [
            "Chewy",
            "Candy",
            "Rainbow"
        ],
        answers: [
            "Skittles",
            "Skittle"
        ],
        hint: "A colorful treat that lets you 'taste the rainbow.'"
    },
    {
        category: "Food",
        clues: [
            "Spread",
            "Hazelnut",
            "Chocolate"
        ],
        answers: [
            "Nutella",
            "Nutella Spread"
        ],
        hint: "A popular chocolate spread often eaten with bread."
    },
    {
        category: "Movies",
        clues: [
            "Robot",
            "Garbage",
            "Space"
        ],
        answers: [
            "WALL-E"
        ],
        hint: "A small robot left to clean up Earth meets a companion in space."
    },
    {
        category: "Literature",
        clues: [
            "Shipwreck",
            "Island",
            "Survival"
        ],
        answers: [
            "Robinson Crusoe"
        ],
        hint: "A tale of a man stranded on an island for many years."
    },
    {
        category: "Sports",
        clues: [
            "Board",
            "Waves",
            "Ocean"
        ],
        answers: [
            "Surfing"
        ],
        hint: "A water sport where you ride waves."
    },
    {
        category: "Technology",
        clues: [
            "Electric",
            "Grid",
            "Renewable"
        ],
        answers: [
            "Solar Panels",
            "Solar Panel"
        ],
        hint: "A clean energy source that captures power from the sun."
    },
    {
        category: "Food",
        clues: [
            "Tiny",
            "Explodes",
            "Party"
        ],
        answers: [
            "Pop Rocks",
            "Pop Rock"
        ],
        hint: "The candy that feels like a fireworks show is going off in your mouth."
    },
    {
        category: "Animals",
        clues: [
            "Invisible",
            "Spooky",
            "Floats"
        ],
        answers: [
            "Ghost Shark"
        ],
        hint: "Not an actual ghost, but still probably haunts your nightmares."
    },
    {
        category: "Technology",
        clues: [
            "Laser",
            "Future",
            "Cutting"
        ],
        answers: [
            "Lightsaber"
        ],
        hint: "The most dramatic way to slice toast in a galaxy far, far away."
    },
    {
        category: "Geography",
        clues: [
            "Cold",
            "Glowing",
            "Northern"
        ],
        answers: [
            "Aurora Borealis",
            "Northern Lights"
        ],
        hint: "That magical sky light show you have to go REALLY far north to see."
    },
    {
        category: "Sports",
        clues: [
            "Brooms",
            "Flying",
            "Golden"
        ],
        answers: [
            "Quidditch",
            "Harry Potter Quidditch"
        ],
        hint: "A game where falling off your broom is highly discouraged."
    },
    {
        category: "Music",
        clues: [
            "Saxophone",
            "Romantic",
            "1980s"
        ],
        answers: [
            "Careless Whisper"
        ],
        hint: "That one sax riff that immediately makes things 100% more dramatic."
    },
    {
        category: "Technology",
        clues: [
            "Cube",
            "Puzzle",
            "Colors"
        ],
        answers: [
            "Rubik's Cube"
        ],
        hint: "The most frustrating way to prove you're not a genius."
    },
    {
        category: "Geography",
        clues: [
            "Triangle",
            "Disappearing",
            "Mystery"
        ],
        answers: [
            "Bermuda Triangle",
            "Devil's Triangle",
            "Bermuda",
            "The Bermuda Triangle"
        ],
        hint: "The place where boats and planes go missing\u2014and it's always spooky."
    },
    {
        category: "Literature",
        clues: [
            "Green Eggs",
            "Rhymes",
            "Whoville"
        ],
        answers: [
            "Dr. Seuss",
            "Dr Seuss",
            "Dr. Seuss' Books",
            "Dr Seuss' Books"
        ],
        hint: "A beloved storyteller whose characters have fur and love breakfast."
    },
    {
        category: "Technology",
        clues: [
            "Virtual",
            "Fantasy",
            "Level-Up"
        ],
        answers: [
            "Video Game",
            "Video Games",
            "Game",
            "Games"
        ],
        hint: "Where you can slay dragons, solve puzzles, or just jump on mushrooms."
    },
    {
        category: "Mythical Creatures",
        clues: [
            "Hairy",
            "Huge",
            "Roars"
        ],
        answers: [
            "Bigfoot",
            "Sasquatch"
        ],
        hint: "The most elusive creature\u2014seen by many, caught by none."
    },
    {
        category: "Technology",
        clues: [
            "Clap",
            "Off",
            "Lights"
        ],
        answers: [
            "The Clapper",
            "Clapper"
        ],
        hint: "The laziest and loudest way to turn off your lights."
    },
    {
        category: "Animals",
        clues: [
            "Red",
            "Sneaky",
            "Bushy Tail"
        ],
        answers: [
            "Fox",
            "Foxes"
        ],
        hint: "This clever animal is famous for asking 'What does it say?'"
    },
    {
        category: "Food",
        clues: [
            "Crispy",
            "Golden",
            "Curly"
        ],
        answers: [
            "French Fries",
            "Fries",
            "French Fry",
            "Fry"
        ],
        hint: "The reason you tell yourself you don\u2019t need to eat vegetables."
    },
    {
        category: "Movies",
        clues: [
            "Talking",
            "Toys",
            "Cowboy"
        ],
        answers: [
            "Toy Story",
            "Toy Story Movies",
            "Toy Story Movie"
        ],
        hint: "A movie where your childhood toys come to life (in a non-creepy way)."
    },
    {
        category: "Geography",
        clues: [
            "Floating",
            "Giant",
            "Melting"
        ],
        answers: [
            "Iceberg",
            "Icebergs",
            "Iceberg Lettuce"
        ],
        hint: "The unsinkable ship's worst nightmare, but it\u2019s still chilling."
    },
    {
        category: "Literature",
        clues: [
            "Crazy",
            "Wonderland",
            "Tea Party"
        ],
        answers: [
            "Alice in Wonderland"
        ],
        hint: "A story where getting lost is an adventure, and nothing makes sense."
    },
    {
        category: "Animals",
        clues: [
            "Horned",
            "Angry",
            "Charging"
        ],
        answers: [
            "Rhino"
        ],
        hint: "This armored-looking beast can run at you like a tank with legs."
    },
    {
        category: "Animals",
        clues: [
            "Armor",
            "Rolls",
            "Ball"
        ],
        answers: [
            "Armadillo"
        ],
        hint: "This critter is basically nature\u2019s version of a medieval knight."
    },
    {
        category: "Food",
        clues: [
            "Green",
            "Spicy",
            "Smash"
        ],
        answers: [
            "Guacamole"
        ],
        hint: "A tasty green dip that's the life of any party\u2014until it's gone."
    },
    {
        category: "Movies",
        clues: [
            "Jaws",
            "Boat",
            "Bigger"
        ],
        answers: [
            "Sharknado"
        ],
        hint: "When sharks meet weather, and it\u2019s exactly as ridiculous as it sounds."
    },
    {
        category: "Geography",
        clues: [
            "Dry",
            "Hot",
            "Cacti"
        ],
        answers: [
            "Sahara Desert"
        ],
        hint: "A place so hot and dry, even the camels have second thoughts."
    },
    {
        category: "Sports",
        clues: [
            "Rink",
            "Puck",
            "Body Check"
        ],
        answers: [
            "Ice Hockey",
            "Hockey"
        ],
        hint: "The only sport where gliding and smashing into someone is completely normal."
    },
    {
        category: "Music",
        clues: [
            "Tuba",
            "Parade",
            "March"
        ],
        answers: [
            "Marching Band",
            "Marching Bands",
            "Band",
            "Bands"
        ],
        hint: "A group that makes walking in formation somehow sound amazing."
    },
    {
        category: "Literature",
        clues: [
            "Giant",
            "Peach",
            "Insects"
        ],
        answers: [
            "James and the Giant Peach",
            "James and the Giant Peach Book",
            "James and the Giant Peach Movie"
        ],
        hint: "A story where the fruit is bigger than the adventure."
    },
    {
        category: "Technology",
        clues: [
            "Screen",
            "Portable",
            "Games"
        ],
        answers: [
            "Game Boy",
            "Gameboy"
        ],
        hint: "The handheld console that kept kids entertained and batteries drained."
    },
    {
        category: "Mythical Creatures",
        clues: [
            "Fire",
            "Wings",
            "Scales"
        ],
        answers: [
            "Dragon",
            "Dragons"
        ],
        hint: "This creature loves gold and has a bad habit of setting things on fire."
    },
    {
        category: "Mythical Creatures",
        clues: [
            "Horn",
            "Magic",
            "Horse"
        ],
        answers: [
            "Unicorn",
            "Unicorns"
        ],
        hint: "A magical horse with a horn, known for spreading rainbows and sparkles."
    },
    {
        category: "Mythical Creatures",
        clues: [
            "Water",
            "Tail",
            "Song"
        ],
        answers: [
            "Mermaid",
            "Mermaids"
        ],
        hint: "Half human, half fish, known for their enchanting voices."
    },
    {
        category: "Superpowers",
        clues: [
            "Disappear",
            "Invisible",
            "Stealth"
        ],
        answers: [
            "Invisibility",
            "Invisible"
        ],
        hint: "The power to sneak around without being seen."
    },
    {
        category: "Superpowers",
        clues: [
            "Time",
            "Jump",
            "Travel"
        ],
        answers: [
            "Time Travel",
            "Time Traveler"
        ],
        hint: "The ability to go backward or forward in time, like a human time machine."
    },
    {
        category: "Superpowers",
        clues: [
            "Mind",
            "Control",
            "Thoughts"
        ],
        answers: [
            "Telepathy",
            "Mind Reading"
        ],
        hint: "Reading minds and hearing thoughts without saying a word."
    },
    {
        category: "Superpowers",
        clues: [
            "Strength",
            "Lift",
            "Smash"
        ],
        answers: [
            "Super Strength",
            "Strength"
        ],
        hint: "The power to lift cars, buildings, and pretty much anything without breaking a sweat."
    },
    {
        category: "Superpowers",
        clues: [
            "Fly",
            "Sky",
            "Wings"
        ],
        answers: [
            "Flight",
            "Flying",
            "Fly"
        ],
        hint: "The ability to soar through the skies faster than a plane."
    },
    {
        category: "Inventions",
        clues: [
            "Portable",
            "Pencil Trick",
            "Tape"
        ],
        answers: [
            "Walkman",
            "Sony Walkman",
            "Cassette Player",
            "Cassette Tape Player"
        ],
        hint: "The retro gadget that let you take your tunes anywhere, one cassette at a time."
    },
    {
        category: "Inventions",
        clues: [
            "Typing",
            "Mechanical",
            "Clicky"
        ],
        answers: [
            "Typewriter",
            "Typewriters",
            "Typing Machine",
            "Typing Machines"
        ],
        hint: "Before keyboards, this clicky invention was the way to write a novel."
    },
    {
        category: "Inventions",
        clues: [
            "Wheels",
            "Glide",
            "Shoes"
        ],
        answers: [
            "Roller Skates",
            "Rollerskates",
            "Rollerskating",
            "Roller Skating",
            "Roller Skate",
            "Roller Blades",
            "Roller Blading",
            "Rollerblade",
            "Rollerblading"
        ],
        hint: "The shoe that turns walking into rolling, usually followed by falling."
    },
    {
        category: "Inventions",
        clues: [
            "Morse",
            "Message",
            "Dots"
        ],
        answers: [
            "Telegraph",
            "Telegraph Machine",
            "Telegraphy"
        ],
        hint: "A 19th-century device that used dots and dashes to send messages across long distances."
    },
    {
        category: "Inventions",
        clues: [
            "Flight",
            "Wright",
            "Propeller"
        ],
        answers: [
            "Airplane",
            "Aeroplane",
            "Plane"
        ],
        hint: "This invention helped people reach new heights\u2014literally."
    },
    {
        category: "Board Games",
        clues: [
            "Wrench",
            "Murder",
            "Scarlett"
        ],
        answers: [
            "Clue"
        ],
        hint: "A mystery-solving game where you figure out who did it in the library with a candlestick."
    },
    {
        category: "Board Games",
        clues: [
            "Money",
            "Houses",
            "Bankruptcy"
        ],
        answers: [
            "Monopoly"
        ],
        hint: "This game is a fast track to becoming a property tycoon\u2014or ending friendships."
    },
    {
        category: "Board Games",
        clues: [
            "Tiles",
            "Letters",
            "Words"
        ],
        answers: [
            "Scrabble"
        ],
        hint: "The game that turns spelling into a competition, one triple word score at a time."
    },
    {
        category: "Board Games",
        clues: [
            "Candy",
            "Path",
            "Sweet"
        ],
        answers: [
            "Candy Land",
            "Candyland"
        ],
        hint: "A colorful, sugary game where you move through a world made of sweets."
    },
    {
        category: "Board Games",
        clues: [
            "Wood",
            "Blocks",
            "Stack"
        ],
        answers: [
            "Jenga"
        ],
        hint: "A game where pulling the wrong block means watching everything tumble down."
    },
    {
        category: "Movies",
        clues: [
            "Video Game",
            "Adventure",
            "Jungle"
        ],
        answers: [
            "Jumanji"
        ],
        hint: "A game comes to life and traps players in a jungle where survival is the goal."
    },
    {
        category: "Movies",
        clues: [
            "Time Travel",
            "Car",
            "1980s"
        ],
        answers: [
            "Back to the Future",
            "BTTF"
        ],
        hint: "A DeLorean, a mad scientist, and a trip to the past gone awry."
    },
    {
        category: "Movies",
        clues: [
            "Pandora",
            "Blue",
            "Alien"
        ],
        answers: [
            "Avatar",
            "Avatar Movie"
        ],
        hint: "In this sci-fi adventure, humans try to colonize a planet full of giant blue aliens."
    },
    {
        category: "Movies",
        clues: [
            "Spy",
            "Martini",
            "MI6"
        ],
        answers: [
            "James Bond",
            "007",
            "Bond",
            "James Bond Movies"
        ],
        hint: "This British agent prefers his martinis shaken, not stirred."
    },
    {
        category: "Movies",
        clues: [
            "High School",
            "Musical",
            "Romance"
        ],
        answers: [
            "Grease",
            "Grease Movie"
        ],
        hint: "A movie where love and leather jackets rule the school halls."
    },
    {
        category: "Movies",
        clues: [
            "Toys",
            "Animated",
            "Buzz"
        ],
        answers: [
            "Toy Story",
            "Toy Story Movies",
            "Toy Story Movie"
        ],
        hint: "A heartwarming tale of toys that come to life when no one's watching."
    },
    {
        category: "Geography",
        clues: [
            "Taj Mahal",
            "Subcontinent",
            "Himalayas"
        ],
        answers: [
            "India",
            "Republic of India"
        ],
        hint: "A country known for the Taj Mahal, spices, and vibrant festivals."
    },
    {
        category: "Geography",
        clues: [
            "River",
            "Egypt",
            "Longest"
        ],
        answers: [
            "Nile River",
            "The Nile"
        ],
        hint: "The world's longest river, flowing through northeastern Africa."
    },
    {
        category: "Music",
        clues: [
            "Guitar",
            "Woodstock",
            "Voodoo Child"
        ],
        answers: [
            "Jimi Hendrix"
        ],
        hint: "A guitar virtuoso who electrified audiences with his iconic performances."
    },
    {
        category: "Music",
        clues: [
            "Rapper",
            "Empire State of Mind",
            "Brooklyn"
        ],
        answers: [
            "Jay-Z",
            "Jay Z"
        ],
        hint: "A hip-hop mogul from New York with a powerful empire."
    },
    {
        category: "Music",
        clues: [
            "Folk",
            "Blowin' in the Wind",
            "Harmonica"
        ],
        answers: [
            "Bob Dylan",
            "Dylan"
        ],
        hint: "A poetic folk musician whose lyrics shaped a generation."
    },
    {
        category: "Music",
        clues: [
            "British",
            "Indie Rock",
            "Do I Wanna Know?"
        ],
        answers: [
            "Arctic Monkeys",
            "The Arctic Monkeys"
        ],
        hint: "A British band known for catchy rock tunes and sleek style."
    },
    {
        category: "Music",
        clues: [
            "Punk Rock",
            "Canadian",
            "Red Flag"
        ],
        answers: [
            "Billy Talent",
            "Billy Talent Band"
        ],
        hint: "A Canadian punk rock band known for energetic performances."
    },
    {
        category: "Music",
        clues: [
            "Punk",
            "American Idiot",
            "Billie Joe"
        ],
        answers: [
            "Green Day",
            "Green Day Band"
        ],
        hint: "A punk rock band that gave us 'American Idiot' and political anthems."
    },
    {
        category: "Music",
        clues: [
            "Rock",
            "Bat",
            "Out of Hell"
        ],
        answers: [
            "Meat Loaf",
            "Meatloaf"
        ],
        hint: "A rock opera legend known for theatrical songs and a fiery voice."
    },
    {
        category: "Music",
        clues: [
            "Producer",
            "Beats",
            "Hip-Hop"
        ],
        answers: [
            "Timbaland",
            "Timbaland Producer"
        ],
        hint: "A famous producer who crafted beats for stars like Missy Elliott and Justin Timberlake."
    },
    {
        category: "Music",
        clues: [
            "Rock",
            "Canadian",
            "Pain"
        ],
        answers: [
            "Three Days Grace",
            "3 Days Grace"
        ],
        hint: "A Canadian rock band known for emotional and intense lyrics."
    },
    {
        category: "Music",
        clues: [
            "Barbados",
            "Umbrella",
            "Pop"
        ],
        answers: [
            "Rihanna"
        ],
        hint: "A pop superstar from Barbados who made us all sing under her 'Umbrella.'"
    },
    {
        category: "Music",
        clues: [
            "Rapper",
            "Get Rich",
            "Candy Shop"
        ],
        answers: [
            "50 Cent",
            "Fifty Cent"
        ],
        hint: "A rapper known for 'In Da Club' and surviving nine gunshots."
    },
    {
        category: "Music",
        clues: [
            "Hip-Hop",
            "Boom Boom Pow",
            "Fergie"
        ],
        answers: [
            "Black Eyed Peas",
            "The Black Eyed Peas"
        ],
        hint: "A group that brought us hits like 'I Gotta Feeling' and 'Let's Get It Started.'"
    },
    {
        category: "Music",
        clues: [
            "Thunder",
            "Rock",
            "Australia"
        ],
        answers: [
            "AC/DC",
            "ACDC",
            "AC DC"
        ],
        hint: "An Australian rock band known for electrifying riffs and 'Highway to Hell.'"
    },
    {
        category: "Music",
        clues: [
            "Yellow",
            "British",
            "Chris Martin"
        ],
        answers: [
            "Coldplay",
            "Cold Play"
        ],
        hint: "A British band that brought us 'Yellow' and atmospheric stadium anthems."
    },
    {
        category: "Music",
        clues: [
            "Dream On",
            "Rock",
            "Steven Tyler"
        ],
        answers: [
            "Aerosmith"
        ],
        hint: "A band with a long career, known for hits like 'Dream On' and 'Walk This Way.'"
    },
    {
        category: "Music",
        clues: [
            "Rock",
            "Stairway",
            "Zeppelin"
        ],
        answers: [
            "Led Zeppelin",
            "Led Zep"
        ],
        hint: "A legendary rock band with the epic 'Stairway to Heaven.'"
    },
    {
        category: "Music",
        clues: [
            "Blues Rock",
            "Duo",
            "Lonely Boy"
        ],
        answers: [
            "The Black Keys",
            "Black Keys"
        ],
        hint: "A blues-rock duo known for hits like 'Tighten Up' and 'Lonely Boy.'"
    },
    {
        category: "Music",
        clues: [
            "Old Time",
            "Rock 'n Roll",
            "Silver Bullet Band"
        ],
        answers: [
            "Bob Seger",
            "Bob Seger Band"
        ],
        hint: "An American rocker who sang about the heartland and 'Old Time Rock 'n Roll.'"
    },
    {
        category: "Music",
        clues: [
            "Pop",
            "Funk",
            "24K Magic"
        ],
        answers: [
            "Bruno Mars"
        ],
        hint: "A pop star who dazzled with 'Uptown Funk' and '24K Magic.'"
    },
    {
        category: "Music",
        clues: [
            "Pop",
            "Ocean Eyes",
            "Teen"
        ],
        answers: [
            "Billie Eilish"
        ],
        hint: "A moody pop artist known for her haunting voice and hit 'Bad Guy.'"
    },
    {
        category: "Music",
        clues: [
            "Californication",
            "Flea",
            "Funky Rock"
        ],
        answers: [
            "Red Hot Chili Peppers",
            "RHCP"
        ],
        hint: "A band that mixes rock and funk with hits like 'Californication' and 'Under the Bridge.'"
    },
    {
        category: "Music",
        clues: [
            "USA",
            "Born",
            "Boss"
        ],
        answers: [
            "Bruce Springsteen"
        ],
        hint: "An American rock icon who sings about the working class and is known as 'The Boss.'"
    },
    {
        category: "Music",
        clues: [
            "Motown",
            "Soul",
            "What's Going On"
        ],
        answers: [
            "Marvin Gaye"
        ],
        hint: "A soul legend who asked 'What's Going On' and gave us 'Sexual Healing.'"
    },
    {
        category: "Music",
        clues: [
            "Rock",
            "Abracadabra",
            "Fly Like an Eagle"
        ],
        answers: [
            "Steve Miller Band",
            "The Steve Miller Band"
        ],
        hint: "A rock band that made us all wanna 'Fly Like an Eagle.'"
    },
    {
        category: "Music",
        clues: [
            "Guitar",
            "Shape of You",
            "British"
        ],
        answers: [
            "Ed Sheeran"
        ],
        hint: "A British singer-songwriter known for 'Shape of You' and acoustic ballads."
    },
    {
        category: "Music",
        clues: [
            "Kryptonite",
            "Rock",
            "Here Without You"
        ],
        answers: [
            "3 Doors Down",
            "Three Doors Down"
        ],
        hint: "A rock band known for hits like 'Kryptonite' and 'Here Without You.'"
    },
    {
        category: "Music",
        clues: [
            "Rock",
            "Slash",
            "Appetite for Destruction"
        ],
        answers: [
            "Guns N' Roses",
            "Guns and Roses",
            "Guns N Roses",
            "Guns 'n Roses"
        ],
        hint: "A rock band led by Axl Rose and Slash, known for 'Sweet Child O' Mine.'"
    },
    {
        category: "Music",
        clues: [
            "Grunge",
            "Seattle",
            "Man in the Box"
        ],
        answers: [
            "Alice in Chains"
        ],
        hint: "A Seattle grunge band known for dark and heavy tracks like 'Man in the Box.'"
    },
    {
        category: "Music",
        clues: [
            "Rock",
            "Josh Homme",
            "No One Knows"
        ],
        answers: [
            "Queens of the Stone Age",
            "QOTSA"
        ],
        hint: "A hard rock band known for driving beats and 'No One Knows.'"
    },
    {
        category: "Music",
        clues: [
            "Rock",
            "Pour Some Sugar",
            "80s"
        ],
        answers: [
            "Def Leppard"
        ],
        hint: "An 80s rock band known for hits like 'Pour Some Sugar on Me.'"
    },
    {
        category: "Music",
        clues: [
            "Boy Band",
            "Pop",
            "I Want It That Way"
        ],
        answers: [
            "Backstreet Boys",
            "BSB"
        ],
        hint: "A legendary 90s boy band that told us 'I Want It That Way.'"
    },
    {
        category: "Music",
        clues: [
            "Canadian",
            "Baby",
            "Pop"
        ],
        answers: [
            "Justin Bieber"
        ],
        hint: "A Canadian pop star who became famous with the hit 'Baby.'"
    },
    {
        category: "Music",
        clues: [
            "Rock",
            "Heavy Metal",
            "Paranoid"
        ],
        answers: [
            "Black Sabbath"
        ],
        hint: "A heavy metal band fronted by Ozzy Osbourne, known for 'Paranoid.'"
    },
    {
        category: "Music",
        clues: [
            "Prince of Darkness",
            "Metal",
            "Crazy Train"
        ],
        answers: [
            "Ozzy Osbourne"
        ],
        hint: "The 'Prince of Darkness' and former frontman of Black Sabbath."
    },
    {
        category: "Music",
        clues: [
            "Africa",
            "Rosanna",
            "Rock"
        ],
        answers: [
            "Toto"
        ],
        hint: "A rock band who blessed the rains down in 'Africa.'"
    },
    {
        category: "Music",
        clues: [
            "Indie",
            "Fun",
            "We Are Young"
        ],
        answers: [
            "Fun.",
            "fun"
        ],
        hint: "An indie pop band known for the hit 'We Are Young.'"
    },
    {
        category: "Music",
        clues: [
            "Rapper",
            "Mr. Worldwide",
            "Miami"
        ],
        answers: [
            "Pitbull"
        ],
        hint: "A rapper who proudly calls himself 'Mr. Worldwide.'"
    },
    {
        category: "Board Games",
        clues: [
            "Bugs",
            "Leaf",
            "Creepy Crawlies"
        ],
        answers: [
            "Ants in the Pants"
        ],
        hint: "A game where plastic insects launch into trousers, and it's supposed to be fun!"
    },
    {
        category: "Board Games",
        clues: [
            "Rodents",
            "Trap",
            "Rube Goldberg"
        ],
        answers: [
            "Mouse Trap",
            "Mousetrap"
        ],
        hint: "You build a crazy contraption to trap rodents... but will it work?"
    },
    {
        category: "Board Games",
        clues: [
            "Phrase",
            "Drawing",
            "Laugh"
        ],
        answers: [
            "Pictionary"
        ],
        hint: "This game turns your terrible art into everyone\u2019s favorite guessing challenge."
    },
    {
        category: "Board Games",
        clues: [
            "Rhino",
            "Balance",
            "Stack"
        ],
        answers: [
            "Rhino Hero"
        ],
        hint: "A game where stacking cards helps a superhero animal save the day!"
    },
    {
        category: "Board Games",
        clues: [
            "Destruction",
            "Towers",
            "Monsters"
        ],
        answers: [
            "King of Tokyo"
        ],
        hint: "Giant monsters battle for control of the city in this action-packed game!"
    },
    {
        category: "Board Games",
        clues: [
            "Robber",
            "Settlers",
            "Resources"
        ],
        answers: [
            "Catan",
            "Settlers of Catan",
            "Settlers",
            "Catan Board Game"
        ],
        hint: "A game where you build settlements, trade resources, and try to dominate the island!"
    },
    {
        category: "Mythical Creatures",
        clues: [
            "Fire",
            "Chicken",
            "Deadly Gaze"
        ],
        answers: [
            "Basilisk"
        ],
        hint: "This serpent-like creature can kill with a single look!"
    },
    {
        category: "Mythical Creatures",
        clues: [
            "Lumberjack",
            "Giant",
            "Blue Ox"
        ],
        answers: [
            "Paul Bunyan"
        ],
        hint: "A larger-than-life figure with an equally giant blue companion."
    },
    {
        category: "Mythical Creatures",
        clues: [
            "Three Heads",
            "Guard",
            "Underworld"
        ],
        answers: [
            "Cerberus"
        ],
        hint: "This terrifying watchdog has three heads and guards the gates of the Underworld."
    },
    {
        category: "Mythical Creatures",
        clues: [
            "Scotland",
            "Lake",
            "Long Neck"
        ],
        answers: [
            "Loch Ness Monster",
            "Nessie",
            "Loch Ness",
            "Lochness Monster",
            "Lochness"
        ],
        hint: "This elusive creature is said to live in the deep waters of a Scottish loch."
    },
    {
        category: "Food",
        clues: [
            "Dough",
            "Twist",
            "Salty"
        ],
        answers: [
            "Pretzel"
        ],
        hint: "This knot-shaped snack is best when it's twisted and salty."
    },
    {
        category: "Food",
        clues: [
            "Cold",
            "Syrup",
            "Crushed Ice"
        ],
        answers: [
            "Snow Cone",
            "Snowcone"
        ],
        hint: "A summer treat that makes eating ice seem like a good idea."
    },
    {
        category: "Board Games",
        clues: [
            "Strategy",
            "Conquer",
            "World"
        ],
        answers: [
            "Risk",
            "Risk Board Game",
            "Risk Game"
        ],
        hint: "A game of world domination, where your friendships are always at risk!"
    },
    {
        category: "Board Games",
        clues: [
            "Ships",
            "Coordinates",
            "Sink"
        ],
        answers: [
            "Battleship"
        ],
        hint: "The game where you shout out letters and numbers hoping to sink someone's fleet."
    },
    {
        category: "Board Games",
        clues: [
            "Colors",
            "Skip",
            "Wild Card"
        ],
        answers: [
            "Uno"
        ],
        hint: "A game where you can turn your best friend into your worst enemy with a single card."
    },
    {
        category: "Board Games",
        clues: [
            "Spinning",
            "Limbs",
            "Mat"
        ],
        answers: [
            "Twister"
        ],
        hint: "A game that turns people into human pretzels."
    },
    {
        category: "Board Games",
        clues: [
            "Red",
            "Yellow",
            "Line-Up"
        ],
        answers: [
            "Connect Four",
            "Connect 4"
        ],
        hint: "A game of lining up circles, but beware of diagonal sneaks!"
    },
    {
        category: "Board Games",
        clues: [
            "Spin",
            "Jobs",
            "Money"
        ],
        answers: [
            "The Game of Life",
            "Game of Life",
            "Life Board Game",
            "Life Game",
            "Life"
        ],
        hint: "This game lets you live out your dream career\u2014or lose it all in a spin."
    },
    {
        category: "Board Games",
        clues: [
            "Exploding",
            "Cards",
            "Cats"
        ],
        answers: [
            "Exploding Kittens"
        ],
        hint: "A strategic card game where you desperately avoid detonating felines."
    },
    {
        category: "Board Games",
        clues: [
            "Cards",
            "RPG",
            "Silly"
        ],
        answers: [
            "Munchkin"
        ],
        hint: "A dungeon crawl card game where cheating and backstabbing are encouraged."
    },
    {
        category: "Board Games",
        clues: [
            "Offensive",
            "Cards",
            "Fill-in-the-blank"
        ],
        answers: [
            "Cards Against Humanity"
        ],
        hint: "The party game for horrible people."
    },
    {
        category: "Food",
        clues: [
            "Creamy",
            "Green",
            "Appetizer"
        ],
        answers: [
            "Spinach Dip"
        ],
        hint: "A warm and creamy appetizer that's often found next to chips."
    },
    {
        category: "Food",
        clues: [
            "Noodles",
            "Sauce",
            "Italy"
        ],
        answers: [
            "Spaghetti"
        ],
        hint: "An Italian classic that can make a mess if you're not careful."
    },
    {
        category: "Food",
        clues: [
            "Crispy",
            "Golden",
            "Drumsticks"
        ],
        answers: [
            "Fried Chicken",
            "Chicken"
        ],
        hint: "A crunchy, finger-lickin' meal that makes napkins a must."
    },
    {
        category: "Food",
        clues: [
            "Sweet",
            "Baked",
            "Chocolate Chip"
        ],
        answers: [
            "Cookies",
            "Cookie"
        ],
        hint: "Small, round treats that are irresistible when fresh out of the oven."
    },
    {
        category: "Food",
        clues: [
            "Small",
            "Frosting",
            "Baked"
        ],
        answers: [
            "Cupcakes",
            "Cupcake"
        ],
        hint: "A mini cake with frosting on top, perfect for a single bite of joy."
    },
    {
        category: "Food",
        clues: [
            "Chocolate",
            "Cream",
            "Twist"
        ],
        answers: [
            "Oreo",
            "Oreo Cookie"
        ],
        hint: "Twist it, lick it, dunk it\u2014this cookie is a classic."
    },
    {
        category: "Food",
        clues: [
            "Sticky",
            "Spread",
            "Jelly's Best Friend"
        ],
        answers: [
            "Peanut Butter",
            "Peanut Butter and Jelly",
            "PB&J"
        ],
        hint: "A sandwich staple that's smooth, creamy, and a little nutty."
    },
    {
        category: "Mythical Creatures",
        clues: [
            "Green",
            "Gold",
            "Irish"
        ],
        answers: [
            "Leprechaun",
            "Leprechauns"
        ],
        hint: "Known for guarding pots of gold and being hard to catch."
    },
    {
        category: "Mythical Creatures",
        clues: [
            "Full Moon",
            "Howl",
            "Transformation"
        ],
        answers: [
            "Werewolf",
            "Werewolves"
        ],
        hint: "A creature that\u2019s only dangerous under the light of a full moon."
    },
    {
        category: "Mythical Creatures",
        clues: [
            "Labyrinth",
            "Bull",
            "Maze"
        ],
        answers: [
            "Minotaur",
            "Minotaurs"
        ],
        hint: "Half-man, half-bull, and a big fan of getting lost in mazes."
    },
    {
        category: "Mythical Creatures",
        clues: [
            "Horse",
            "Wings",
            "Fly"
        ],
        answers: [
            "Pegasus",
            "Pegasi"
        ],
        hint: "A winged horse that can fly through the skies."
    },
    {
        category: "Mythical Creatures",
        clues: [
            "Tentacles",
            "Sea",
            "Giant"
        ],
        answers: [
            "Kraken",
            "Krakens"
        ],
        hint: "A massive sea creature known for dragging ships down into the depths."
    },
    {
        category: "Mythical Creatures",
        clues: [
            "Human",
            "Bird",
            "Deadly Song"
        ],
        answers: [
            "Siren",
            "Sirens"
        ],
        hint: "A creature whose beautiful voice lures sailors to their doom."
    },
    {
        category: "Mythical Creatures",
        clues: [
            "Fire",
            "Bird",
            "Rebirth"
        ],
        answers: [
            "Phoenix",
            "Phoenixes"
        ],
        hint: "A bird that bursts into flames and is reborn from its ashes."
    },
    {
        category: "Mythical Creatures",
        clues: [
            "One Eye",
            "Giant",
            "Greek"
        ],
        answers: [
            "Cyclops",
            "Cyclopes"
        ],
        hint: "A one-eyed giant who likes smashing things with a club."
    },
    {
        category: "Superpowers",
        clues: [
            "Objects",
            "Control",
            "Move"
        ],
        answers: [
            "Telekinesis",
            "Telekinetic"
        ],
        hint: "The ability to move things without touching them."
    },
    {
        category: "Superpowers",
        clues: [
            "Time",
            "Freeze",
            "Pause"
        ],
        answers: [
            "Time Stopping",
            "Time Stop",
            "Time Freeze",
            "Time-Freezing",
            "Time-Stopping",
            "Time-Pausing",
            "Time-Pause"
        ],
        hint: "This power lets you pause the world and keep moving while time stands still."
    },
    {
        category: "Superpowers",
        clues: [
            "Morph",
            "Shape",
            "Form"
        ],
        answers: [
            "Shapeshifting",
            "Shape-Shifting",
            "Shape Shifting",
            "Shapeshifter",
            "Shape Shifter",
            "Shape-Shifter",
            "Morphing",
            "Morph",
            "Shapeshift"
        ],
        hint: "The ability to change your appearance into anything or anyone."
    },
    {
        category: "Superpowers",
        clues: [
            "Weather",
            "Storm",
            "Lightning"
        ],
        answers: [
            "Weather Manipulation",
            "Weather Control",
            "Weather Manipulator",
            "Weather Controller",
            "Weather Manipulating",
            "Weather Controlling",
            "Weather-Manipulating",
            "Weather-Controlling"
        ],
        hint: "The power to summon storms or sunny skies at will."
    },
    {
        category: "Superpowers",
        clues: [
            "Heal",
            "Regrow",
            "Invincible"
        ],
        answers: [
            "Regeneration",
            "Regrow",
            "Regrowing",
            "Regenerate",
            "Regenerating",
            "Regeneration"
        ],
        hint: "A power that lets you heal from any injury almost instantly."
    },
    {
        category: "Inventions",
        clues: [
            "Jump",
            "Stick",
            "Boing"
        ],
        answers: [
            "Pogo Stick",
            "Pogo Sticks"
        ],
        hint: "An invention that makes bouncing around on two feet look easy (but it's not)."
    },
    {
        category: "Inventions",
        clues: [
            "Hot",
            "Drink",
            "Insulated"
        ],
        answers: [
            "Thermos",
            "Thermos Flask",
            "Thermos Bottle"
        ],
        hint: "This container keeps your coffee hot (or your drinks cold) for hours."
    },
    {
        category: "Inventions",
        clues: [
            "Virtual",
            "Friends",
            "Pets"
        ],
        answers: [
            "Tamagotchi"
        ],
        hint: "A digital pet that fit in your pocket and demanded constant attention."
    },
    {
        category: "As Seen on TV",
        clues: [
            "Kitchen",
            "Slice",
            "Veggies"
        ],
        answers: [
            "Slap Chop",
            "Slapchop"
        ],
        hint: "An invention that lets you dice and slice food with a single smack."
    },
    {
        category: "As Seen on TV",
        clues: [
            "Blanket",
            "Sleeves",
            "Couch"
        ],
        answers: [
            "Snuggie",
            "Snuggies",
            "Snuggie Blanket"
        ],
        hint: "A wearable blanket that keeps you warm and leaves your hands free."
    },
    {
        category: "As Seen on TV",
        clues: [
            "Mop",
            "Water",
            "360"
        ],
        answers: [
            "Spin Mop",
            "Spin Mops"
        ],
        hint: "A mop that spins itself dry with a twirl."
    },
    {
        category: "As Seen on TV",
        clues: [
            "Seal",
            "Waterproof",
            "Tape"
        ],
        answers: [
            "Flex Tape",
            "Flex Tape Roll",
            "Flex Tape Waterproof Tape",
            "Flex Products",
            "Flex Seal",
            "Flex Glue",
            "Flex",
            "Flex Family of Products"
        ],
        hint: "This tape can fix just about anything, even a leaky boat!"
    },
    {
        category: "As Seen on TV",
        clues: [
            "Oven",
            "Crispy",
            "Air"
        ],
        answers: [
            "Air Fryer",
            "Air Fryers",
            "Air Fryer Oven",
            "Air Fryer Machine"
        ],
        hint: "A kitchen gadget that promises fried food without the grease."
    },
    {
        category: "As Seen on TV",
        clues: [
            "Chop",
            "Cook",
            "Quick"
        ],
        answers: [
            "Magic Bullet",
            "Magic Bullet Blender",
            "Magic Bullet Mixer",
            "Magic Bullet Food Processor"
        ],
        hint: "A compact blender that promises to make smoothies in seconds."
    },
    {
        category: "As Seen on TV",
        clues: [
            "Flex",
            "Exercise",
            "Shake"
        ],
        answers: [
            "Shake Weight",
            "Shake Weights"
        ],
        hint: "An exercise tool that uses shaking motion to tone muscles... and it looks ridiculous."
    },
    {
        category: "As Seen on TV",
        clues: [
            "Tape",
            "Seal",
            "Strong"
        ],
        answers: [
            "Flex Tape",
            "Flex Tape Roll",
            "Flex Tape Waterproof Tape",
            "Flex Products",
            "Flex Seal",
            "Flex Glue",
            "Flex",
            "Flex Family of Products"
        ],
        hint: "This tape can fix anything\u2014even a leaking boat, if you believe the ads!"
    },
    {
        category: "As Seen on TV",
        clues: [
            "Spray",
            "Seal",
            "Waterproof"
        ],
        answers: [
            "Flex Seal",
            "Flex Products",
            "Flex",
            "Flex Family of Products"
        ],
        hint: "A spray that claims to stop leaks and seal cracks with just a coat."
    },
    {
        category: "As Seen on TV",
        clues: [
            "Furniture",
            "Protect",
            "Feet"
        ],
        answers: [
            "Furniture Feet",
            "Furniture Foot",
            "Furniture Leg Covers",
            "Furniture Leg Pads"
        ],
        hint: "These little cups protect your floors from those heavy chairs and couches."
    },
    {
        category: "As Seen on TV",
        clues: [
            "Stuffed",
            "Pillow",
            "Animal"
        ],
        answers: [
            "Pillow Pet",
            "Pillow Pets"
        ],
        hint: "It\u2019s a stuffed animal that unfolds into a cozy pillow for bedtime cuddles."
    },
    {
        category: "As Seen on TV",
        clues: [
            "Sticky",
            "Lint",
            "Reusable"
        ],
        answers: [
            "Schticky",
            "Schticky Lint Roller",
            "Schticky Lint Roller Set",
            "Sticky"
        ],
        hint: "A reusable lint roller that sticks to everything and then washes clean."
    },
    {
        category: "As Seen on TV",
        clues: [
            "Plant",
            "Grow",
            "Clay"
        ],
        answers: [
            "Chia Pet",
            "Chia Pets"
        ],
        hint: "Just add water, and watch this iconic clay figure sprout greenery!"
    },
    {
        category: "As Seen on TV",
        clues: [
            "Smiling",
            "Sponge",
            "Scrub"
        ],
        answers: [
            "Scrub Daddy",
            "Scrub Daddy Sponge",
            "Scrub Mommy",
            "Dish Daddy",
            "Scrub Daddy Family",
            "Scrub Daddy Products"
        ],
        hint: "A smiley sponge that changes texture based on water temperature."
    },
    {
        category: "As Seen on TV",
        clues: [
            "Clean",
            "Stain",
            "Laundry"
        ],
        answers: [
            "OxiClean",
            "Oxi Clean",
            "Oxy Clean",
            "OxyClean"
        ],
        hint: "This cleaning product is known for its stain-fighting powers, especially in laundry."
    },
    {
        category: "As Seen on TV",
        clues: [
            "Toilet",
            "Feet",
            "Comfort"
        ],
        answers: [
            "Squatty Potty",
            "Squatty Potty Toilet Stool",
            "Squatty Potty Stool",
            "Squatty Potty Bathroom Stool",
            "Squatty Potty Toilet Stool",
            "Squatty Potty Bathroom Stool"
        ],
        hint: "This device helps you, well... squat while using the toilet, for 'better results.'"
    },
    {
        category: "Cartoon Characters",
        clues: [
            "Square",
            "Cheerful",
            "Absorbent"
        ],
        answers: [
            "SpongeBob SquarePants",
            "SpongeBob"
        ],
        hint: "Lives somewhere that's far from dry, and he\u2019s quite absorbent."
    },
    {
        category: "Cartoon Characters",
        clues: [
            "Colorful",
            "Paws",
            "Clues"
        ],
        answers: [
            "Blue",
            "Blue's Clues",
            "Blues Clues"
        ],
        hint: "This one loves to leave hints behind, especially with their paws."
    },
    {
        category: "Cartoon Characters",
        clues: [
            "Iconic",
            "Gloves",
            "Smile"
        ],
        answers: [
            "Mickey Mouse",
            "Mickey",
            "Mickey Mouse Clubhouse"
        ],
        hint: "Famous for his gloves and a huge influence on an entertainment empire."
    },
    {
        category: "Cartoon Characters",
        clues: [
            "Lazy",
            "Monday",
            "Sarcastic"
        ],
        answers: [
            "Garfield",
            "Garfield the Cat",
            "Garfield Cat"
        ],
        hint: "Not a fan of a certain day and prefers snacking over work."
    },
    {
        category: "Cartoon Characters",
        clues: [
            "Duo",
            "Experiment",
            "Takeover"
        ],
        answers: [
            "Pinky",
            "Pinky and the Brain",
            "The Brain"
        ],
        hint: "One of two lab partners, always caught in elaborate schemes."
    },
    {
        category: "Cartoon Characters",
        clues: [
            "Quick",
            "Trickster",
            "Vegetable"
        ],
        answers: [
            "Bugs Bunny",
            "Bugs",
            "Bugs Bunny Rabbit"
        ],
        hint: "Often outwits his rivals with clever tricks and munches on something orange."
    },
    {
        category: "Cartoon Characters",
        clues: [
            "Cowardly",
            "Van",
            "Snacks"
        ],
        answers: [
            "Scooby-Doo",
            "Scooby Doo",
            "Scooby"
        ],
        hint: "Loves snacks and is often found on the run from things that go bump in the night."
    },
    {
        category: "Cartoon Characters",
        clues: [
            "Alien",
            "Chaos",
            "Family"
        ],
        answers: [
            "Stitch",
            "Lilo and Stitch",
            "Lilo & Stitch"
        ],
        hint: "This troublemaker from a distant place finds a new family."
    },
    {
        category: "Cartoon Characters",
        clues: [
            "Enormous",
            "Colorful",
            "Best Friend"
        ],
        answers: [
            "Clifford",
            "Clifford the Big Red Dog",
            "Clifford Dog"
        ],
        hint: "A friend who's hard to miss, especially because of his size and color."
    },
    {
        category: "Cartoon Characters",
        clues: [
            "Grumpy",
            "Small",
            "Team"
        ],
        answers: [
            "Grumpy",
            "Grumpy Dwarf",
            "Grumpy Dwarf Snow White"
        ],
        hint: "Not a fan of joy, and he's often found alongside a small group."
    },
    {
        category: "Cartoon Characters",
        clues: [
            "Hungry",
            "Clever",
            "Stone Age"
        ],
        answers: [
            "Fred Flintstone",
            "Fred",
            "Flintstone"
        ],
        hint: "Lives in prehistoric times but still enjoys modern conveniences like drive-thrus."
    },
    {
        category: "Cartoon Characters",
        clues: [
            "Gadget",
            "Detective",
            "Clumsy"
        ],
        answers: [
            "Inspector Gadget",
            "Gadget"
        ],
        hint: "A detective who has more tools than he knows how to use, literally."
    },
    {
        category: "Cartoon Characters",
        clues: [
            "Fast",
            "Red",
            "Catch"
        ],
        answers: [
            "Road Runner",
            "Roadrunner"
        ],
        hint: "Always outruns someone with a knack for falling into their own traps."
    },
    {
        category: "Cartoon Characters",
        clues: [
            "Smart",
            "Rabbit",
            "Bothered"
        ],
        answers: [
            "Bugs Bunny",
            "Bugs",
            "Bugs Bunny Rabbit"
        ],
        hint: "A wisecracking character that always seems to be one step ahead."
    },
    {
        category: "Cartoon Characters",
        clues: [
            "Pink",
            "Starfish",
            "Loyal"
        ],
        answers: [
            "Patrick Star",
            "Patrick",
            "Patrick Starfish"
        ],
        hint: "A simple friend who lives under a rock, quite literally."
    },
    {
        category: "Cartoon Characters",
        clues: [
            "Science",
            "Invention",
            "Accident-prone"
        ],
        answers: [
            "Dexter",
            "Dexter's Laboratory",
            "Dexter Lab"
        ],
        hint: "A genius with a secret lab, often disturbed by a sibling."
    },
    {
        category: "Cartoon Characters",
        clues: [
            "Pirate",
            "Green",
            "Plank"
        ],
        answers: [
            "Plankton",
            "Sheldon Plankton"
        ],
        hint: "A tiny villain with big plans, usually involving secret recipes."
    },
    {
        category: "Cartoon Characters",
        clues: [
            "Lazy",
            "Big",
            "Jelly"
        ],
        answers: [
            "Winnie the Pooh",
            "Pooh Bear",
            "Pooh"
        ],
        hint: "A sweet-toothed bear with a preference for sticky treats."
    },
    {
        category: "Cartoon Characters",
        clues: [
            "Flying",
            "Cape",
            "Alien"
        ],
        answers: [
            "Superman",
            "Clark Kent"
        ],
        hint: "Has a hidden identity but is known for his powers, especially in the skies."
    },
    {
        category: "Cartoon Characters",
        clues: [
            "Teen",
            "Dog",
            "Detective"
        ],
        answers: [
            "Velma",
            "Velma Dinkley",
            "Velma Scooby Doo"
        ],
        hint: "A mystery solver known for her brains and her constantly missing glasses."
    },
    {
        category: "Cartoon Characters",
        clues: [
            "Fast",
            "Blue",
            "Rings"
        ],
        answers: [
            "Sonic the Hedgehog",
            "Sonic"
        ],
        hint: "A blue blur who\u2019s always on the run, collecting shiny objects along the way."
    },
    {
        category: "Cartoon Characters",
        clues: [
            "Magic",
            "Genie",
            "Lamp"
        ],
        answers: [
            "Aladdin",
            "Aladdin Disney",
            "Aladdin Genie"
        ],
        hint: "This character\u2019s life changed after finding a very powerful friend inside something small."
    },
    {
        category: "Cartoon Characters",
        clues: [
            "Dog",
            "Silly",
            "Disney"
        ],
        answers: [
            "Goofy",
            "Goofy Disney"
        ],
        hint: "This clumsy but lovable character is known for his funny laugh and big shoes."
    },
    {
        category: "Cartoon Characters",
        clues: [
            "Mischief",
            "Tiny",
            "Red Bow"
        ],
        answers: [
            "Elmo",
            "Elmo Sesame Street",
            "Elmo Muppet",
            "Elmo Monster",
            "Elmo Red"
        ],
        hint: "This small, furry character loves to laugh and is a big fan of tickles."
    },
    {
        category: "Cartoon Characters",
        clues: [
            "Green",
            "Swamp",
            "Grumpy"
        ],
        answers: [
            "Shrek",
            "Shrek Ogre",
            "Shrek Movie"
        ],
        hint: "An ogre who prefers his quiet life in the swamp but often ends up in grand adventures."
    },
    {
        category: "Cartoon Characters",
        clues: [
            "Little",
            "Squeaky",
            "Cat Rival"
        ],
        answers: [
            "Jerry",
            "Tom and Jerry",
            "Tom & Jerry"
        ],
        hint: "This tiny creature is always outsmarting his larger, feline foe."
    },
    {
        category: "Cartoon Characters",
        clues: [
            "Friendship",
            "Pony",
            "Magic"
        ],
        answers: [
            "Twilight Sparkle",
            "Twilight My Little Pony",
            "Twilight Pony"
        ],
        hint: "A magical character who values friendship above all and leads with kindness."
    },
    {
        category: "Cartoon Characters",
        clues: [
            "Martial Arts",
            "Turtle",
            "Mutant"
        ],
        answers: [
            "Leonardo from Teenage Mutant Ninja Turtles",
            "Leonardo Ninja Turtle",
            "Leonardo TMNT",
            "Leonardo Turtle",
            "Leonardo",
            "Teeeage Mutant Ninja Turtles",
            "TMNT"
        ],
        hint: "A leader among his brothers, known for his blue mask and sword skills."
    },
    {
        category: "Celebrities",
        clues: [
            "Actor",
            "Action",
            "Governor"
        ],
        answers: [
            "Arnold Schwarzenegger",
            "Arnold Schwarzenegger Actor",
            "Arnold Schwarzenegger Governor"
        ],
        hint: "An action star who swapped Hollywood for politics."
    },
    {
        category: "Celebrities",
        clues: [
            "Talk Show",
            "Comedian",
            "Ellen"
        ],
        answers: [
            "Ellen DeGeneres",
            "Ellen DeGeneres Show",
            "Ellen"
        ],
        hint: "Known for her dance moves and hosting a daytime talk show with lots of surprises."
    },
    {
        category: "Celebrities",
        clues: [
            "Marvel",
            "Iron Man",
            "Comeback"
        ],
        answers: [
            "Robert Downey Jr.",
            "Robert Downey Jr Actor",
            "Robert Downey"
        ],
        hint: "An actor famous for playing a genius superhero in a metal suit."
    },
    {
        category: "Celebrities",
        clues: [
            "Reality",
            "Makeup",
            "Family"
        ],
        answers: [
            "Kim Kardashian",
            "Kim Kardashian West",
            "Kim Kardashian Reality Star"
        ],
        hint: "A reality star known for her famous family and business ventures."
    },
    {
        category: "Celebrities",
        clues: [
            "Actor",
            "Pirate",
            "Tim Burton"
        ],
        answers: [
            "Johnny Depp",
            "Johnny Depp Actor",
            "Johnny Depp Pirates of the Caribbean"
        ],
        hint: "A versatile actor known for roles as a swashbuckling pirate and other quirky characters."
    },
    {
        category: "Celebrities",
        clues: [
            "Actor",
            "Director",
            "Hollywood Legend"
        ],
        answers: [
            "Clint Eastwood",
            "Clint Eastwood Actor",
            "Clint Eastwood Director"
        ],
        hint: "Famous for his tough-guy roles and a legendary career behind the camera as well."
    },
    {
        category: "Celebrities",
        clues: [
            "Chef",
            "Gordon",
            "Hell's Kitchen"
        ],
        answers: [
            "Gordon Ramsay",
            "Gordon Ramsay Chef",
            "Gordon Ramsay Hell's Kitchen"
        ],
        hint: "This fiery chef is known for his kitchen outbursts and culinary expertise."
    },
    {
        category: "Celebrities",
        clues: [
            "Talk Show",
            "Queen",
            "Book Club"
        ],
        answers: [
            "Oprah Winfrey",
            "Oprah Winfrey Show",
            "Oprah Winfrey Book Club"
        ],
        hint: "A media mogul known for her show, her generosity, and a famous book club."
    },
    {
        category: "Celebrities",
        clues: [
            "Supermodel",
            "Victoria\u2019s Secret",
            "America\u2019s Got Talent"
        ],
        answers: [
            "Heidi Klum"
        ],
        hint: "A supermodel who also judges talent competitions and hosts Halloween parties."
    },
    {
        category: "Celebrities",
        clues: [
            "Actor",
            "Comedy",
            "Deadpool"
        ],
        answers: [
            "Ryan Reynolds",
            "Ryan Reynolds Actor",
            "Ryan Reynolds Deadpool"
        ],
        hint: "A Canadian actor known for his quick wit and breaking the fourth wall in superhero movies."
    },
    {
        category: "Celebrities",
        clues: [
            "Comedy",
            "Duo",
            "Stoner"
        ],
        answers: [
            "Cheech & Chong",
            "Cheech and Chong"
        ],
        hint: "A comedy pair famous for their movies about laid-back lifestyles."
    },
    {
        category: "Celebrities",
        clues: [
            "Actor",
            "Scientist",
            "Jurassic Park"
        ],
        answers: [
            "Jeff Goldblum"
        ],
        hint: "Known for playing eccentric characters, including a quirky scientist who deals with dinosaurs."
    },
    {
        category: "Celebrities",
        clues: [
            "Actor",
            "King of Cool",
            "Great Escape"
        ],
        answers: [
            "Steve McQueen"
        ],
        hint: "A legendary actor known for his roles as a tough and rebellious leading man."
    },
    {
        category: "Celebrities",
        clues: [
            "Director",
            "Sci-Fi",
            "Exploration"
        ],
        answers: [
            "James Cameron"
        ],
        hint: "This director is known for films set on the ocean floor and in far-off, blue-skinned worlds."
    },
    {
        category: "Celebrities",
        clues: [
            "Comedy",
            "Sketch",
            "The Mask"
        ],
        answers: [
            "Jim Carrey"
        ],
        hint: "An actor famous for his zany, rubber-faced antics in comedies and dramas alike."
    },
    {
        category: "Celebrities",
        clues: [
            "Actress",
            "Wizard",
            "Brown"
        ],
        answers: [
            "Emma Watson"
        ],
        hint: "She played a brilliant witch with a love of books and went on to become a UN ambassador."
    },
    {
        category: "Celebrities",
        clues: [
            "Action",
            "Martial Arts",
            "Rush Hour"
        ],
        answers: [
            "Jackie Chan"
        ],
        hint: "A martial arts master known for performing his own stunts in action-packed movies."
    },
    {
        category: "Celebrities",
        clues: [
            "Actress",
            "Comedy",
            "Legally Blonde"
        ],
        answers: [
            "Reese Witherspoon"
        ],
        hint: "A bubbly actress who starred in a film about proving brains and beauty go hand in hand."
    },
    {
        category: "Celebrities",
        clues: [
            "Actor",
            "Jedi",
            "Lightsaber"
        ],
        answers: [
            "Mark Hamill"
        ],
        hint: "Known for his role in a galaxy far, far away as a young farm boy who becomes a Jedi."
    },
    {
        category: "Celebrities",
        clues: [
            "Actor",
            "Action",
            "John Wick"
        ],
        answers: [
            "Keanu Reeves"
        ],
        hint: "This actor has gained a cult following for his calm, humble demeanor and action roles."
    },
    {
        category: "Music",
        clues: [
            "Grunge",
            "Seattle",
            "Teen Spirit"
        ],
        answers: [
            "Nirvana"
        ],
        hint: "A grunge band that defined a generation with angst and 'Smells Like' something."
    },
    {
        category: "Music",
        clues: [
            "California",
            "Stadium Rock",
            "Hotel"
        ],
        answers: [
            "Hotel California",
            "Eagles"
        ],
        hint: "A song about a place you can check in anytime, but you can never leave."
    },
    {
        category: "Music",
        clues: [
            "Pink",
            "Brick",
            "Wall"
        ],
        answers: [
            "The Wall",
            "Pink Floyd",
            "Another Brick in the Wall"
        ],
        hint: "This iconic rock album is all about barriers, both mental and physical."
    },
    {
        category: "Music",
        clues: [
            "Christmas",
            "Diva",
            "High Notes"
        ],
        answers: [
            "Mariah Carey"
        ],
        hint: "A pop diva known for her multi-octave vocal range and a certain holiday song."
    },
    {
        category: "Music",
        clues: [
            "Jazz",
            "Blue Eyes",
            "Rat Pack"
        ],
        answers: [
            "Frank Sinatra",
            "Sinatra"
        ],
        hint: "A crooner with timeless classics and an unmistakable voice, often called 'Ol' Blue Eyes.'"
    },
    {
        category: "Inventions",
        clues: [
            "Blend",
            "Hide",
            "Military"
        ],
        answers: [
            "Camouflage",
            "Camo"
        ],
        hint: "This invention helps people or animals blend into their surroundings, making them hard to spot."
    },
    {
        category: "Fashion",
        clues: [
            "Designer",
            "Luxury",
            "Interlocking Gs"
        ],
        answers: [
            "Gucci"
        ],
        hint: "A luxury brand known for high-end fashion and its iconic 'double G' logo."
    },
    {
        category: "Fashion",
        clues: [
            "Sporty",
            "Three Stripes",
            "Shoes"
        ],
        answers: [
            "Adidas"
        ],
        hint: "A global sportswear brand, instantly recognizable by its three-stripe design."
    },
    {
        category: "Fashion",
        clues: [
            "Street Style",
            "Sneakers",
            "Check"
        ],
        answers: [
            "Converse"
        ],
        hint: "Known for their timeless high-top sneakers with a star on the side."
    },
    {
        category: "Fashion",
        clues: [
            "Iconic",
            "Luxury",
            "Bags"
        ],
        answers: [
            "Louis Vuitton"
        ],
        hint: "This brand is famous for its luxury handbags and 'LV' monogram."
    },
    {
        category: "Fashion",
        clues: [
            "Eyewear",
            "Sunglasses",
            "Aviator"
        ],
        answers: [
            "Ray-Ban",
            "Ray Ban"
        ],
        hint: "A popular sunglasses brand known for its aviators and Wayfarers."
    },
    {
        category: "Fashion",
        clues: [
            "Outerwear",
            "Quilted",
            "British"
        ],
        answers: [
            "Burberry"
        ],
        hint: "A British fashion house known for its trench coats and iconic check pattern."
    },
    {
        category: "Fashion",
        clues: [
            "Jeans",
            "Denim",
            "American"
        ],
        answers: [
            "Levi's",
            "Levis"
        ],
        hint: "An American brand that revolutionized denim and is still famous for its jeans."
    },
    {
        category: "Fashion",
        clues: [
            "Classic",
            "Tailored",
            "Tie"
        ],
        answers: [
            "Suit"
        ],
        hint: "A timeless formal outfit often worn with a tie, seen in offices and special events."
    },
    {
        category: "TV Shows",
        clues: [
            "Paper",
            "Dunder Mifflin",
            "Scranton"
        ],
        answers: [
            "The Office",
            "Office"
        ],
        hint: "A mockumentary about a mundane paper company, featuring a hilarious boss."
    },
    {
        category: "TV Shows",
        clues: [
            "Group",
            "Coffee Shop",
            "NYC"
        ],
        answers: [
            "Friends",
            "Friends TV Show"
        ],
        hint: "Six friends navigate life and relationships, often meeting at Central Perk."
    },
    {
        category: "TV Shows",
        clues: [
            "Glass",
            "Chemistry",
            "New Mexico"
        ],
        answers: [
            "Breaking Bad"
        ],
        hint: "A former chemistry teacher turns to cooking something illegal in the desert."
    },
    {
        category: "TV Shows",
        clues: [
            "Law",
            "Criminal",
            "Order"
        ],
        answers: [
            "Law & Order",
            "Law and Order"
        ],
        hint: "A procedural show that follows detectives and lawyers in New York."
    },
    {
        category: "TV Shows",
        clues: [
            "Comedy",
            "Family",
            "Quirky"
        ],
        answers: [
            "Modern Family"
        ],
        hint: "A mockumentary about three different but related families living in California."
    },
    {
        category: "TV Shows",
        clues: [
            "FBI",
            "Unsolved",
            "Profiles"
        ],
        answers: [
            "Criminal Minds"
        ],
        hint: "A show that follows a team of FBI agents who profile and catch serial criminals."
    },
    {
        category: "TV Shows",
        clues: [
            "Reality",
            "Survival",
            "Island"
        ],
        answers: [
            "Survivor"
        ],
        hint: "Contestants are stranded in remote locations, competing to 'outwit, outplay, outlast.'"
    },
    {
        category: "TV Shows",
        clues: [
            "Comedy",
            "Apartment",
            "New York"
        ],
        answers: [
            "Seinfeld"
        ],
        hint: "A show famously about 'nothing,' centered around a stand-up comedian and his friends."
    },
    {
        category: "TV Shows",
        clues: [
            "Animated",
            "Yellow",
            "Springfield"
        ],
        answers: [
            "The Simpsons",
            "Simpsons"
        ],
        hint: "The longest-running animated TV show about a quirky family in a fictional town."
    },
    {
        category: "TV Shows",
        clues: [
            "Mob",
            "Therapist",
            "Crime"
        ],
        answers: [
            "The Sopranos"
        ],
        hint: "A mob boss balances his crime family with therapy and personal struggles."
    },
    {
        category: "TV Shows",
        clues: [
            "Fantasy",
            "Magic School",
            "BBC"
        ],
        answers: [
            "Merlin"
        ],
        hint: "A reimagining of a famous wizard's early days at a magical kingdom."
    },
    {
        category: "TV Shows",
        clues: [
            "Royalty",
            "History",
            "British"
        ],
        answers: [
            "The Crown",
            "Crown"
        ],
        hint: "A dramatized look at the life and reign of Queen Elizabeth II."
    },
    {
        category: "TV Shows",
        clues: [
            "Hospital",
            "Doctors",
            "Grey"
        ],
        answers: [
            "Grey's Anatomy",
            "Greys Anatomy"
        ],
        hint: "A medical drama that follows the personal and professional lives of doctors at a hospital."
    },
    {
        category: "Fashion",
        clues: [
            "Formal",
            "Bow",
            "Accessory"
        ],
        answers: [
            "Bow Tie",
            "Bowtie"
        ],
        hint: "A formal accessory, often worn at black-tie events, but also favored by quirky fashionistas."
    },
    {
        category: "Fashion",
        clues: [
            "Jewelry",
            "Finger",
            "Marriage"
        ],
        answers: [
            "Wedding Ring",
            "Wedding Band",
            "Engagement Ring"
        ],
        hint: "A timeless piece of jewelry, often a symbol of eternal love and commitment."
    },
    {
        category: "Fashion",
        clues: [
            "Workwear",
            "Denim",
            "Durable"
        ],
        answers: [
            "Carhartt"
        ],
        hint: "A brand that began with tough workwear and is now a staple of street style."
    },
    {
        category: "Fashion",
        clues: [
            "Running",
            "Shoes",
            "Swoosh"
        ],
        answers: [
            "Nike"
        ],
        hint: "An athletic brand whose 'Just Do It' slogan is as famous as its swoosh logo."
    },
    {
        category: "Fashion",
        clues: [
            "Casual",
            "Fleece",
            "Jacket"
        ],
        answers: [
            "Hoodie"
        ],
        hint: "A popular casual top with a hood, often worn for comfort or during workouts."
    },
    {
        category: "TV Shows",
        clues: [
            "Law",
            "Lawyer",
            "Harvey"
        ],
        answers: [
            "Suits",
            "Suits TV Show"
        ],
        hint: "A legal drama about a hotshot lawyer and his brilliant associate, who happens to have no law degree."
    },
    {
        category: "TV Shows",
        clues: [
            "Nerds",
            "Science",
            "Bazinga"
        ],
        answers: [
            "The Big Bang Theory",
            "Big Bang Theory"
        ],
        hint: "A comedy about a group of geeky friends and their socially awkward antics, with a famous catchphrase."
    },
    {
        category: "TV Shows",
        clues: [
            "Genius",
            "Young",
            "Texas"
        ],
        answers: [
            "Young Sheldon",
            "Sheldon"
        ],
        hint: "A spin-off prequel that follows the childhood of a boy prodigy growing up in a small town."
    },
    {
        category: "TV Shows",
        clues: [
            "Politics",
            "D.C.",
            "Manipulation"
        ],
        answers: [
            "House of Cards",
            "House of Cards TV Show"
        ],
        hint: "A political thriller about the rise of a ruthless politician in Washington, D.C."
    },
    {
        category: "TV Shows",
        clues: [
            "Family",
            "Sitcom",
            "80s"
        ],
        answers: [
            "The Goldbergs"
        ],
        hint: "A sitcom that follows a family in the 1980s through the eyes of the youngest son, who documents their lives."
    },
    {
        category: "TV Shows",
        clues: [
            "Coffee",
            "Writers",
            "Drama"
        ],
        answers: [
            "Gilmore Girls"
        ],
        hint: "A witty drama about a fast-talking mother-daughter duo and their lives in a small town."
    },
    {
        category: "TV Shows",
        clues: [
            "Doctor",
            "Time Travel",
            "TARDIS"
        ],
        answers: [
            "Doctor Who",
            "Dr. Who"
        ],
        hint: "A British sci-fi series about a time-traveling alien with a love for saving the universe."
    },
    {
        category: "TV Shows",
        clues: [
            "Island",
            "Crash",
            "Survivors"
        ],
        answers: [
            "Lost"
        ],
        hint: "A mystery drama where survivors of a plane crash find themselves on a strange island full of secrets."
    },
    {
        category: "TV Shows",
        clues: [
            "Miami",
            "Roommates",
            "Seniors"
        ],
        answers: [
            "The Golden Girls"
        ],
        hint: "A sitcom about four older women living together and sharing hilarious life moments in Miami."
    },
    {
        category: "TV Shows",
        clues: [
            "Roommates",
            "Misunderstanding",
            "Comedy"
        ],
        answers: [
            "Three's Company",
            "Threes Company"
        ],
        hint: "A classic sitcom about a man living with two women, filled with comic misunderstandings."
    },
    {
        category: "TV Shows",
        clues: [
            "Multiverse",
            "Grandfather",
            "Science"
        ],
        answers: [
            "Rick and Morty"
        ],
        hint: "An animated show about a genius scientist and his anxious grandson exploring bizarre universes."
    },
    {
        category: "TV Shows",
        clues: [
            "Games",
            "Survival",
            "Korean"
        ],
        answers: [
            "Squid Game",
            "Squidgame"
        ],
        hint: "A dystopian drama where contestants compete in deadly versions of children's games for a chance to win a huge prize."
    },
    {
        category: "TV Shows",
        clues: [
            "Hospital",
            "Surgery",
            "Comedy"
        ],
        answers: [
            "Scrubs"
        ],
        hint: "A comedy-drama about the lives of medical interns and their hilarious (and heartfelt) moments."
    },
    {
        category: "TV Shows",
        clues: [
            "Soap Opera",
            "Hospital",
            "Drama"
        ],
        answers: [
            "General Hospital"
        ],
        hint: "One of the longest-running daytime TV shows, set in a fictional hospital."
    },
    {
        category: "TV Shows",
        clues: [
            "Soap Opera",
            "British",
            "Street"
        ],
        answers: [
            "Coronation Street"
        ],
        hint: "A long-running British soap opera centered around the residents of a fictional street."
    },
    {
        category: "TV Shows",
        clues: [
            "Comedy",
            "MASH",
            "War"
        ],
        answers: [
            "MASH",
            "M*A*S*H"
        ],
        hint: "A classic comedy-drama set in a mobile army hospital during the Korean War."
    }
];


document.addEventListener("DOMContentLoaded", ()=>{
    const game = new (0, $472cb95d11c6e757$export$985739bfa5723e08)((0, $59cc4cc8e38f3e25$export$b770c311badf26d4));
});


//# sourceMappingURL=index.04cb0702.js.map
